// Credit to FA
export const ReactIcon = ({ logoFill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width || '48'}
    height={height || '48'}
  >
    <path
      fill={logoFill || '#ffffff'}
      d="M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1 .9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2 .6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6 .4 19.5 .6 29.5 .6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8 .9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
    />
  </svg>
);

// Credit to Icons8
export const ReactIconColor = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width={width || '48'}
    height={height || '48'}
  >
    <linearGradient
      id="9GkdZLxQa1XTDblOFwLcpa"
      x1="32"
      x2="32"
      y1="25.213"
      y2="36.722"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#6dc7ff" />
      <stop offset="1" stopColor="#e6abff" />
    </linearGradient>
    <circle cx="32" cy="32" r="6" fill="url(#9GkdZLxQa1XTDblOFwLcpa)" />
    <linearGradient
      id="9GkdZLxQa1XTDblOFwLcpb"
      x1="32"
      x2="32"
      y1="7.426"
      y2="53.44"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#1a6dff" />
      <stop offset="1" stopColor="#c822ff" />
    </linearGradient>
    <path
      fill="url(#9GkdZLxQa1XTDblOFwLcpb)"
      d="M58,32c0-3.758-4.243-7.017-10.853-8.992c0.221-1.031,0.407-2.045,0.524-3.015	c0.657-5.483-0.483-9.323-3.211-10.813c-2.729-1.489-6.574-0.372-10.831,3.146c-0.544,0.449-1.087,0.938-1.629,1.45	c-0.542-0.513-1.085-1.001-1.629-1.45C26.114,8.808,22.267,7.692,19.54,9.18c-2.728,1.489-3.868,5.329-3.211,10.813	c0.116,0.971,0.303,1.984,0.524,3.015C10.243,24.983,6,28.242,6,32s4.243,7.017,10.853,8.992c-0.221,1.031-0.407,2.045-0.524,3.015	c-0.657,5.483,0.483,9.323,3.211,10.813c0.789,0.431,1.67,0.643,2.628,0.643c2.357,0,5.177-1.287,8.203-3.788	c0.544-0.449,1.087-0.938,1.629-1.45c0.542,0.513,1.085,1.001,1.629,1.45c3.026,2.501,5.846,3.788,8.203,3.788	c0.958,0,1.84-0.213,2.628-0.643c2.728-1.489,3.868-5.329,3.211-10.813c-0.116-0.971-0.303-1.984-0.524-3.015	C53.757,39.017,58,35.758,58,32z M34.902,13.866c3.53-2.917,6.665-3.987,8.599-2.931c1.934,1.055,2.729,4.27,2.184,8.818	c-0.105,0.879-0.273,1.796-0.469,2.729c-2.117-0.519-4.43-0.915-6.892-1.166c-1.564-2.275-3.215-4.351-4.908-6.132	C33.91,14.718,34.406,14.276,34.902,13.866z M39.899,36.313c-0.853,1.562-1.76,3.055-2.702,4.474C35.546,40.925,33.811,41,32,41	s-3.546-0.075-5.198-0.213c-0.941-1.42-1.849-2.912-2.702-4.474c-0.784-1.435-1.499-2.878-2.142-4.313	c0.643-1.434,1.358-2.877,2.142-4.313c0.853-1.562,1.76-3.055,2.702-4.474C28.454,23.075,30.189,23,32,23s3.546,0.075,5.198,0.213	c0.941,1.42,1.849,2.912,2.702,4.474c0.784,1.435,1.499,2.878,2.142,4.313C41.399,33.434,40.683,34.877,39.899,36.313z M43.078,34.487c0.68,1.739,1.238,3.444,1.676,5.096c-1.544,0.376-3.21,0.694-5.009,0.929c0.657-1.05,1.3-2.124,1.909-3.241	C42.161,36.346,42.629,35.416,43.078,34.487z M32,47.403c-1.272-1.341-2.522-2.863-3.729-4.513C29.487,42.961,30.73,43,32,43	s2.513-0.039,3.729-0.11C34.522,44.54,33.272,46.062,32,47.403z M24.254,40.512c-1.799-0.235-3.465-0.553-5.009-0.929	c0.438-1.652,0.996-3.358,1.676-5.096c0.45,0.93,0.918,1.859,1.423,2.785C22.954,38.388,23.597,39.462,24.254,40.512z M20.922,29.513c-0.68-1.739-1.238-3.445-1.676-5.096c1.544-0.376,3.21-0.694,5.009-0.929c-0.657,1.05-1.3,2.124-1.909,3.241	C21.839,27.654,21.371,28.584,20.922,29.513z M32,16.597c1.272,1.341,2.522,2.863,3.729,4.513C34.513,21.039,33.27,21,32,21	s-2.513,0.039-3.729,0.11C29.478,19.46,30.728,17.938,32,16.597z M41.655,26.729c-0.609-1.116-1.252-2.19-1.909-3.241	c1.799,0.235,3.465,0.553,5.009,0.929c-0.438,1.652-0.996,3.358-1.676,5.096C42.629,28.584,42.161,27.654,41.655,26.729z M18.315,19.754c-0.546-4.549,0.25-7.764,2.184-8.818c0.488-0.267,1.053-0.397,1.681-0.397c1.86,0,4.278,1.147,6.918,3.328	c0.496,0.41,0.993,0.852,1.488,1.319c-1.693,1.781-3.345,3.856-4.908,6.132c-2.463,0.251-4.776,0.648-6.892,1.166	C18.588,21.55,18.421,20.633,18.315,19.754z M8,32c0-2.6,3.47-5.303,9.317-7.06c0.606,2.279,1.437,4.654,2.471,7.06	c-1.034,2.407-1.865,4.782-2.471,7.06C11.47,37.303,8,34.6,8,32z M29.098,50.134c-3.53,2.917-6.662,3.989-8.599,2.931	c-1.934-1.055-2.729-4.27-2.184-8.818c0.105-0.879,0.273-1.796,0.469-2.729c2.117,0.519,4.43,0.915,6.892,1.166	c1.564,2.275,3.215,4.351,4.908,6.132C30.09,49.282,29.594,49.724,29.098,50.134z M45.685,44.246	c0.546,4.549-0.25,7.764-2.184,8.818c-1.934,1.059-5.068-0.014-8.599-2.931c-0.496-0.41-0.993-0.852-1.488-1.319	c1.693-1.781,3.345-3.856,4.908-6.132c2.463-0.251,4.776-0.648,6.892-1.166C45.412,42.45,45.579,43.367,45.685,44.246z M46.683,39.06c-0.606-2.279-1.437-4.654-2.471-7.06c1.034-2.407,1.865-4.782,2.471-7.06C52.53,26.697,56,29.4,56,32	S52.53,37.303,46.683,39.06z"
    />
  </svg>
);

export const MobileIcon = ({ logoFill, width, height }) => (
  <svg
    // version="1.1"
    // id="Icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={width || '48'}
    height={height || '48'}
  >
    <path
      fill={logoFill || '#fff'}
      d="M19,8c0.6,0,1-0.4,1-1V5c0-1.7-1.3-3-3-3H7C5.3,2,4,3.3,4,5v22c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3v-4c0-0.6-0.4-1-1-1H6V8
      H19z M11,25h2c0.6,0,1,0.4,1,1s-0.4,1-1,1h-2c-0.6,0-1-0.4-1-1S10.4,25,11,25z"
    />
    <g>
      <path
        fill={logoFill || '#fff'}
        d="M14,19c-0.3,0-0.5-0.1-0.7-0.3l-3-3c-0.4-0.4-0.4-1,0-1.4l3-3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L12.4,15l2.3,2.3
        c0.4,0.4,0.4,1,0,1.4C14.5,18.9,14.3,19,14,19z"
      />
    </g>
    <g>
      <path
        fill={logoFill || '#fff'}
        d="M24,19c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l2.3-2.3l-2.3-2.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3,3
        c0.4,0.4,0.4,1,0,1.4l-3,3C24.5,18.9,24.3,19,24,19z"
      />
    </g>
    <g>
      <path
        fill={logoFill || '#fff'}
        d="M17,20c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.7-0.8-0.4-1.3l4-8c0.2-0.5,0.8-0.7,1.3-0.4c0.5,0.2,0.7,0.8,0.4,1.3l-4,8
        C17.7,19.8,17.4,20,17,20z"
      />
    </g>
  </svg>
);

export const LaptopIcon = ({ logoFill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width={width || '48'}
    height={height || '48'}
  >
    <path
      fill={logoFill || '#fff'}
      d="M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"
    />
  </svg>
);

export const CloudIcon = ({ logoFill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width || '48'}
    height={height || '48'}
    fill="none"
    stroke={logoFill || '#fff'}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
  </svg>
);

export const IntegrationsIcon = ({ logoFill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width || '48'}
    height={height || '48'}
    fill="none"
    stroke={logoFill || '#fff'}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

export const DatabaseIcon = ({ logoFill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width || '48'}
    height={height || '48'}
    fill="none"
    stroke={logoFill || '#fff'}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
  </svg>
);

export const SoftwareIcon = ({ logoFill, width, height }) => (
  <svg
    fill="#000000"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    // xmlns:xlink="http://www.w3.org/1999/xlink"
    width={width || '48'}
    height={height || '48'}
    viewBox="0 0 419.931 419.931"
    // xml:space="preserve"
  >
    <g>
      <g>
        <g>
          <path
            fill={logoFill || '#fff'}
            d="M282.895,352.367c-2.176-1.324-4.072-3.099-5.579-5.25c-0.696-0.992-1.284-2.041-1.771-3.125H28.282V100.276h335.624
				v159.138c7.165,0.647,13.177,5.353,15.701,11.797c2.235-1.225,4.726-1.982,7.344-2.213c1.771-0.154,3.53-0.044,5.236,0.293
				V39.561c0-12.996-10.571-23.569-23.566-23.569H23.568C10.573,15.992,0,26.565,0,39.561v309.146
				c0,12.996,10.573,23.568,23.568,23.568h257.179c-2.007-4.064-2.483-8.652-1.302-13.066
				C280.126,356.67,281.304,354.354,282.895,352.367z M338.025,55.569c0-4.806,3.896-8.703,8.702-8.703h8.702
				c4.807,0,8.702,3.896,8.702,8.703v9.863c0,4.806-3.896,8.702-8.702,8.702h-8.702c-4.807,0-8.702-3.896-8.702-8.702V55.569z
				 M297.56,55.569c0-4.806,3.896-8.703,8.702-8.703h8.703c4.807,0,8.702,3.896,8.702,8.703v9.863c0,4.806-3.896,8.702-8.702,8.702
				h-8.703c-4.806,0-8.702-3.896-8.702-8.702V55.569z M257.094,55.569c0-4.806,3.897-8.703,8.702-8.703h8.702
				c4.807,0,8.703,3.896,8.703,8.703v9.863c0,4.806-3.896,8.702-8.703,8.702h-8.702c-4.805,0-8.702-3.896-8.702-8.702V55.569z"
          />
          <path
            fill={logoFill || '#fff'}
            d="M419.875,335.77l-2.615-14.83c-0.353-1.997-2.256-3.331-4.255-2.979l-13.188,2.324c-1.583-3.715-3.605-7.195-6.005-10.38
				l8.614-10.268c0.626-0.744,0.931-1.709,0.847-2.68c-0.086-0.971-0.554-1.867-1.3-2.494l-11.534-9.68
				c-0.746-0.626-1.713-0.93-2.683-0.845c-0.971,0.085-1.867,0.552-2.493,1.298l-8.606,10.26c-3.533-1.8-7.312-3.188-11.271-4.104
				v-13.392c0-2.028-1.645-3.674-3.673-3.674h-15.06c-2.027,0-3.673,1.646-3.673,3.674v13.392
				c-3.961,0.915-7.736,2.304-11.271,4.104l-8.608-10.259c-1.304-1.554-3.62-1.756-5.175-0.453l-11.535,9.679
				c-0.746,0.627-1.213,1.523-1.299,2.494c-0.084,0.971,0.22,1.937,0.846,2.683l8.615,10.266c-2.396,3.184-4.422,6.666-6.005,10.38
				l-13.188-2.325c-1.994-0.351-3.901,0.982-4.255,2.979l-2.614,14.83c-0.169,0.959,0.05,1.945,0.607,2.744
				c0.561,0.799,1.41,1.342,2.37,1.511l13.198,2.326c0.215,4.089,0.927,8.045,2.073,11.812l-11.6,6.695
				c-0.844,0.485-1.459,1.289-1.712,2.229c-0.252,0.941-0.119,1.943,0.367,2.787l7.529,13.041c0.485,0.844,1.289,1.459,2.229,1.711
				c0.313,0.084,0.632,0.125,0.951,0.125c0.639,0,1.272-0.166,1.836-0.492l11.609-6.703c2.73,2.925,5.812,5.517,9.18,7.709
				l-4.584,12.593c-0.332,0.916-0.289,1.926,0.123,2.809s1.157,1.566,2.072,1.898l14.148,5.149c0.406,0.148,0.832,0.224,1.257,0.224
				c0.53,0,1.063-0.115,1.554-0.345c0.883-0.411,1.564-1.157,1.897-2.073l4.583-12.593c1.965,0.238,3.965,0.361,5.994,0.361
				s4.029-0.125,5.994-0.361l4.584,12.593c0.332,0.916,1.016,1.662,1.897,2.073c0.49,0.229,1.021,0.345,1.554,0.345
				c0.424,0,0.85-0.074,1.256-0.224l14.15-5.149c0.913-0.332,1.659-1.017,2.07-1.898c0.412-0.883,0.456-1.893,0.123-2.809
				l-4.584-12.591c3.365-2.192,6.447-4.786,9.18-7.709l11.609,6.703c0.563,0.324,1.197,0.492,1.836,0.492
				c0.318,0,0.64-0.043,0.951-0.125c0.941-0.252,1.743-0.869,2.229-1.711l7.529-13.043c0.486-0.842,0.619-1.846,0.367-2.787
				c-0.253-0.938-0.868-1.742-1.712-2.229l-11.598-6.693c1.146-3.768,1.856-7.724,2.071-11.812l13.198-2.327
				c0.96-0.169,1.812-0.712,2.37-1.511C419.825,337.715,420.044,336.729,419.875,335.77z M354.184,359.336
				c-11.155,0-20.2-9.045-20.2-20.201s9.046-20.2,20.2-20.2c11.156,0,20.201,9.044,20.201,20.2S365.34,359.336,354.184,359.336z"
          />
          <g>
            <path
              fill={logoFill || '#fff'}
              d="M164.695,235.373c0-4.752-2.785-9.117-7.096-11.119l-39.455-18.332l39.456-18.334c4.31-2.004,7.095-6.368,7.095-11.118
					v-0.319c0-4.21-2.119-8.075-5.665-10.334c-1.962-1.253-4.247-1.916-6.606-1.916c-1.778,0-3.563,0.391-5.16,1.133l-63.078,29.333
					c-4.309,2.004-7.092,6.368-7.092,11.117v0.877c0,4.743,2.782,9.104,7.093,11.118l63.084,29.336
					c1.631,0.755,3.368,1.138,5.162,1.138c2.338,0,4.616-0.664,6.597-1.924c3.548-2.268,5.666-6.13,5.666-10.335L164.695,235.373
					L164.695,235.373z"
            />
            <path
              fill={logoFill || '#fff'}
              d="M226.932,134.012c-2.301-3.15-6.002-5.03-9.901-5.03h-0.314c-5.354,0-10.048,3.425-11.679,8.516L163.478,266.27
					c-1.183,3.718-0.517,7.813,1.781,10.962c2.301,3.148,6.002,5.029,9.901,5.029h0.315c5.352,0,10.043-3.426,11.672-8.516
					l41.555-128.762C229.896,141.268,229.234,137.167,226.932,134.012z"
            />
            <path
              fill={logoFill || '#fff'}
              d="M308.001,194.366l-63.079-29.333c-1.592-0.74-3.374-1.131-5.152-1.131c-2.358,0-4.644,0.661-6.605,1.912
					c-3.552,2.263-5.671,6.127-5.671,10.337v0.319c0,4.746,2.783,9.111,7.097,11.123l39.454,18.33l-39.455,18.331
					c-4.311,2.002-7.096,6.367-7.096,11.119v0.321c0,4.205,2.119,8.066,5.669,10.336c1.974,1.258,4.254,1.923,6.595,1.923
					c1.792,0,3.527-0.383,5.169-1.141l63.082-29.336c4.307-2.009,7.088-6.371,7.088-11.114v-0.877
					C315.094,200.735,312.311,196.371,308.001,194.366z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const TypescriptIcon = ({ width, height, logoFill, backgroundFill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width || '48'}
    height={height || '48'}
  >
    <rect width="36" height="36" x="6" y="6" fill={backgroundFill || '#1976d2'} />
    <polygon
      fill={logoFill || '#fff'}
      points="27.49,22 14.227,22 14.227,25.264 18.984,25.264 18.984,40 22.753,40 22.753,25.264 27.49,25.264"
    />
    <path
      fill={logoFill || '#fff'}
      d="M39.194,26.084c0,0-1.787-1.192-3.807-1.192s-2.747,0.96-2.747,1.986 c0,2.648,7.381,2.383,7.381,7.712c0,8.209-11.254,4.568-11.254,4.568V35.22c0,0,2.152,1.622,4.733,1.622s2.483-1.688,2.483-1.92 c0-2.449-7.315-2.449-7.315-7.878c0-7.381,10.658-4.469,10.658-4.469L39.194,26.084z"
    />
  </svg>
);
// Credit to Icons8
export const JavascriptIcon = ({ logoFill, backgroundFill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width || '48'}
    height={height || '48'}
  >
    <path fill={backgroundFill || '#ffd600'} d="M6,42V6h36v36H6z" />
    <path
      fill={logoFill || '#000001'}
      d="M29.538 32.947c.692 1.124 1.444 2.201 3.037 2.201 1.338 0 2.04-.665 2.04-1.585 0-1.101-.726-1.492-2.198-2.133l-.807-.344c-2.329-.988-3.878-2.226-3.878-4.841 0-2.41 1.845-4.244 4.728-4.244 2.053 0 3.528.711 4.592 2.573l-2.514 1.607c-.553-.988-1.151-1.377-2.078-1.377-.946 0-1.545.597-1.545 1.377 0 .964.6 1.354 1.985 1.951l.807.344C36.452 29.645 38 30.839 38 33.523 38 36.415 35.716 38 32.65 38c-2.999 0-4.702-1.505-5.65-3.368L29.538 32.947zM17.952 33.029c.506.906 1.275 1.603 2.381 1.603 1.058 0 1.667-.418 1.667-2.043V22h3.333v11.101c0 3.367-1.953 4.899-4.805 4.899-2.577 0-4.437-1.746-5.195-3.368L17.952 33.029z"
    />
  </svg>
);

export const UnityIcon = ({ logoFill, backgroundFill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width || '48'}
    height={height || '48'}
    baseProfile="basic"
  >
    <linearGradient
      id="qUxyI3vgFveub1eDoKLJXa"
      x1="-3.608"
      x2="66.534"
      y1="8.061"
      y2="48.557"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#262626" stopOpacity="0" />
      <stop offset="1" stopColor="#262626" stopOpacity=".8" />
    </linearGradient>
    <polygon
      fill={backgroundFill || 'url(#qUxyI3vgFveub1eDoKLJXa)'}
      points="24,45 5,35 5,13 24,3 43,13 43,35"
    />
    <linearGradient
      id="qUxyI3vgFveub1eDoKLJXb"
      x1="-3.231"
      x2="64.117"
      y1="8.199"
      y2="47.082"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#262626" stopOpacity="0" />
      <stop offset="1" stopColor="#262626" stopOpacity=".8" />
    </linearGradient>
    <path
      fill={logoFill || 'url(#qUxyI3vgFveub1eDoKLJXb)'}
      d="M43,31.502V13L27,4.579v4.969c0,1.114,0.617,2.136,1.603,2.655l5.127,2.698L24,20.534	l-9.729-5.633l5.127-2.698C20.383,11.684,21,10.662,21,9.548V4.579L5,13v18.502l4.543-2.726C10.447,28.233,11,27.257,11,26.203	V19.94l10,5.789v10.911l-5.381-2.832c-0.927-0.488-2.042-0.457-2.941,0.082l-4.573,2.744L24,45l15.894-8.365l-4.573-2.744	c-0.899-0.539-2.013-0.57-2.941-0.082L27,36.641V25.729l10-5.789v6.263c0,1.054,0.553,2.03,1.457,2.572L43,31.502z"
    />
  </svg>
);

export const UnityIcon2 = ({ logoFill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    width={width || '48'}
    height={height || '48'}
  >
    <path
      fill={logoFill || '#fff'}
      d="M 44.082031 25.207031 L 46.902344 20.429688 C 47.015625 20.191406 47.03125 19.917969 46.945313 19.671875 L 41.359375 3.671875 C 41.1875 3.183594 40.675781 2.90625 40.179688 3.027344 L 23.761719 7.027344 C 23.449219 7.105469 23.191406 7.328125 23.070313 7.628906 L 21.324219 12 L 16 12 C 15.722656 12 15.453125 12.117188 15.265625 12.320313 L 3.265625 25.320313 C 2.894531 25.722656 2.914063 26.347656 3.308594 26.722656 L 15.894531 38.722656 C 16.078125 38.902344 16.328125 39 16.582031 39 L 22.320313 39 L 24.070313 43.371094 C 24.199219 43.695313 24.488281 43.925781 24.828125 43.984375 L 42.289063 46.984375 C 42.34375 46.996094 42.402344 47 42.457031 47 C 42.921875 47 43.332031 46.679688 43.433594 46.214844 L 46.976563 29.984375 C 47.03125 29.734375 46.988281 29.472656 46.851563 29.25 Z M 21.324219 12 L 35.417969 9.417969 L 28 24 L 11.167969 24 Z M 22.324219 39 L 11.167969 28 L 28 28 L 36.75 41.167969 Z M 40.386719 38.898438 L 32 26 L 39.332031 11.417969 L 44.082031 25.210938 Z"
    />
  </svg>
);

export const UnityIconColor = ({ logoFill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width={width || '48'}
    height={height || '48'}
  >
    <linearGradient
      id="k4Wi0sDN9ImZC~anEGVOCa"
      x1="29.399"
      x2="29.399"
      y1="21.083"
      y2="44.334"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#6dc7ff" />
      <stop offset="1" stopColor="#e6abff" />
    </linearGradient>
    <polygon
      fill="url(#k4Wi0sDN9ImZC~anEGVOCa)"
      points="33,31 38.706,19.782 27.919,21.758 20.093,31"
    />
    <linearGradient
      id="k4Wi0sDN9ImZC~anEGVOCb"
      x1="41.474"
      x2="41.474"
      y1="21.083"
      y2="44.334"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#6dc7ff" />
      <stop offset="1" stopColor="#e6abff" />
    </linearGradient>
    <polygon
      fill="url(#k4Wi0sDN9ImZC~anEGVOCb)"
      points="42.467,22.128 37,33 43.193,42.524 45.948,32.313"
    />
    <linearGradient
      id="k4Wi0sDN9ImZC~anEGVOCc"
      x1="29.976"
      x2="29.976"
      y1="21.083"
      y2="44.334"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#6dc7ff" />
      <stop offset="1" stopColor="#e6abff" />
    </linearGradient>
    <polygon
      fill="url(#k4Wi0sDN9ImZC~anEGVOCc)"
      points="20.422,35 28.735,43.181 39.53,44.825 33,35"
    />
    <linearGradient
      id="k4Wi0sDN9ImZC~anEGVOCd"
      x1="29.834"
      x2="30.211"
      y1="7.965"
      y2="57.379"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#1a6dff" />
      <stop offset="1" stopColor="#c822ff" />
    </linearGradient>
    <path
      fill="url(#k4Wi0sDN9ImZC~anEGVOCd)"
      d="M47.458,55.001c-0.115,0-0.233-0.01-0.354-0.032l-17.443-2.998	c-0.681-0.116-1.262-0.587-1.519-1.228L26.646,47h-5.063c-0.514,0-1.003-0.195-1.377-0.551L7.62,34.447	c-0.785-0.747-0.826-2.005-0.09-2.804l12.001-13.001C19.908,18.234,20.443,18,21,18h4.646l1.496-3.743	c0.239-0.598,0.756-1.047,1.383-1.201l16.417-4c0.984-0.234,2.029,0.333,2.361,1.284l5.585,16.001	c0.174,0.503,0.145,1.041-0.082,1.518l-2.539,4.31l2.411,3.518c0.298,0.486,0.385,1.007,0.275,1.512l-3.543,16.229	C49.213,54.339,48.392,55.001,47.458,55.001z M47.457,53.001l0.001,1L47.457,53.001C47.458,53.001,47.458,53.001,47.457,53.001z M28.898,47.248L30,50.001L47.457,53L51,36.771l-1.517-2.211l-3.715,13.758l-9.92-15.255l8.657-17.216l4.816,13.986l1.72-2.913	l-5.627-15.922l-16.415,4l-1.076,2.69l14.301-2.62L33.613,32H14.011l10.156-12H21L9,33l12.584,12h3.301L13.729,34h19.808	L43.83,49.49L28.898,47.248z M28.038,45.096l11.632,1.748L32.464,36H18.605l9.128,9l0.142,0.063L28.038,45.096z M38.151,32.937	l6.854,10.538l2.992-11.082l0.019-0.158l-0.028-0.137L44.16,20.986L38.151,32.937z M18.323,30h14.063l6.223-12.235l-11.754,2.154	L18.323,30z"
    />
  </svg>
);

export const CSharpIcon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width={width || '48'}
    height={height || '48'}
    baseProfile="basic"
  >
    <linearGradient
      id="dFMIpH0DLBLP_Mye2ctJMa"
      x1="15.25"
      x2="15.25"
      y1="31.296"
      y2="15.385"
      gradientTransform="matrix(1 0 0 -1 0 64)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#8ab4ff" />
      <stop offset=".699" stopColor="#e492ff" />
    </linearGradient>
    <path
      fill="url(#dFMIpH0DLBLP_Mye2ctJMa)"
      d="M19.09,39.37c0,0.01,0.01,0.01,0.01,0.02l-7.7,4.5L19.09,39.37z"
    />
    <linearGradient
      id="dFMIpH0DLBLP_Mye2ctJMb"
      x1="15.25"
      x2="15.25"
      y1="33.329"
      y2="20.11"
      gradientTransform="matrix(1 0 0 -1 0 64)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#8ab4ff" />
      <stop offset=".699" stopColor="#e492ff" />
    </linearGradient>
    <path
      fill="url(#dFMIpH0DLBLP_Mye2ctJMb)"
      d="M19.09,39.37c0,0.01,0.01,0.01,0.01,0.02	l-7.7,4.5L19.09,39.37z"
    />
    <linearGradient
      id="dFMIpH0DLBLP_Mye2ctJMc"
      x1="31.87"
      x2="31.87"
      y1="10.7"
      y2="35.152"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#8ab4ff" />
      <stop offset="1" stopColor="#e492ff" />
    </linearGradient>
    <path
      fill="url(#dFMIpH0DLBLP_Mye2ctJMc)"
      d="M32,8.21l-20.6,11.9v23.78l7.69-4.52	c-1.18-2.17-1.85-4.65-1.85-7.3c0-2.88,0.8-5.56,2.18-7.87c2.68-4.46,7.57-7.46,13.15-7.46c5.27,0,10.11,2.67,12.94,7.12l-0.39,0.24	l-6.57,3.87c-1.35-1.99-3.57-3.16-5.98-3.16c-2.62,0-4.91,1.39-6.19,3.47c-0.68,1.11-1.07,2.4-1.07,3.79c0,1.16,0.27,2.25,0.75,3.22	l6.13-3.6h0.01l0.04,0.02l20.1-11.75L32,8.21z"
    />
    <linearGradient
      id="dFMIpH0DLBLP_Mye2ctJMd"
      x1="32"
      x2="32"
      y1="8.058"
      y2="57.784"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#1a6dff" />
      <stop offset="1" stopColor="#c822ff" />
    </linearGradient>
    <path
      fill="url(#dFMIpH0DLBLP_Mye2ctJMd)"
      d="M32.24,31.71l-6.17,3.6	c1.19,2.38,3.66,4.02,6.5,4.02c2.382,0,4.553-1.156,5.911-3.063l7.076,3.931C42.76,44.666,37.897,47.4,32.57,47.4	c-5.8,0-10.87-3.24-13.47-8.01l-7.7,4.5L32,55.79l20.6-11.9v-0.22V20.11l-0.26-0.15L32.24,31.71z M51,31h-2v2h2v2h-2v2h-2v-2h-2v2	h-2v-2h-2v-2h2v-2h-2v-2h2v-2h2v2h2v-2h2v2h2V31z M45,31h2v2h-2V31z M55.1,16.93L33.5,4.46c-0.93-0.53-2.07-0.53-3,0L8.9,16.93	c-0.92,0.54-1.5,1.53-1.5,2.6v24.94c0,1.07,0.58,2.06,1.5,2.6l21.6,12.47c0.93,0.53,2.07,0.53,3,0l21.6-12.47	c0.92-0.54,1.5-1.53,1.5-2.6V19.53C56.6,18.46,56.02,17.47,55.1,16.93z M54.6,44.47c0,0.36-0.19,0.69-0.5,0.87L32.5,57.81	c-0.31,0.17-0.69,0.17-1,0L9.9,45.34c-0.31-0.18-0.5-0.51-0.5-0.87V19.53c0-0.36,0.19-0.69,0.5-0.87L31.5,6.19	c0.31-0.17,0.69-0.17,1,0l21.6,12.47c0.31,0.18,0.5,0.51,0.5,0.87V44.47z"
    />
  </svg>
);

export const StorybookIcon = ({ width, height, backgroundFill }) => (
  <svg
    width={width || '48'}
    height={height || '48'}
    preserveAspectRatio="xMidYMid"
    viewBox="0 25 256 319"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path
        id="a"
        d="m9.87245893 293.324145-9.86099779-262.7509283c-.3256701-8.6776325 6.32802782-16.0318249 14.99485846-16.5735018l223.4880694-13.96800436c8.821799-.55136241 16.420248 6.15315109 16.971611 14.97495016.020773.3323713.031167.6653101.031167.99833v286.3136053c0 8.839012-7.165435 16.004447-16.004448 16.004447-.239453 0-.478875-.005374-.718087-.016117l-213.6270715-9.594673c-8.3199296-.373675-14.9627611-7.06565-15.27510157-15.388108z"
      />
      <mask id="b" fill={backgroundFill || '#fff'}>
        <use fill={backgroundFill || '#fff'} href="#a" />
      </mask>
    </defs>
    <use fill="#ff4785" href="#a" />
    <path
      d="m188.665358 39.126973 1.526545-36.71548766 30.691632-2.41148534 1.32222 37.8634126c.046016 1.317734-.984915 2.423272-2.302649 2.4692883-.564237.0197036-1.117199-.1611913-1.560697-.5105633l-11.83568-9.323726-14.013155 10.6298328c-1.050497.7968662-2.548081.5912577-3.344947-.4592396-.335442-.4422072-.506327-.9874722-.483269-1.5420318zm-39.251655 80.853336c0 6.226666 41.941975 3.242387 47.572316-1.131416 0-42.4021104-22.751978-64.6837519-64.414689-64.6837519-41.6627118 0-65.0056495 22.6283131-65.0056495 56.5707999 0 59.116499 79.7796605 60.247915 79.7796605 92.493278 0 9.05133-4.432203 14.425558-14.18305 14.425558-12.70565 0-17.728814-6.488863-17.137853-28.551479 0-4.786197-48.4587575-6.278336-49.9361587 0-3.7620647 53.465572 29.5480226 68.887096 67.6649717 68.887096 36.935028 0 65.89209-19.687271 65.89209-55.326883 0-63.359309-80.961582-61.662185-80.961582-93.058985 0-12.7284338 9.455368-14.425558 15.069492-14.425558 5.909604 0 16.546892 1.0415999 15.660452 24.801341z"
      fill={backgroundFill || '#fff'}
      mask="url(#b)"
    />
  </svg>
);

export const MongoDBIcon = ({ width, height, backgroundFill }) => (
  <svg
    viewBox="0 0 128 128"
    width={width || '48'}
    height={height || '48'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-rule="evenodd" fillRule="evenodd">
      <path
        d="m87.259 100.139c.169-.325.331-.612.469-.909.087-.19.221-.228.41-.223 1.133.032 2.266.067 3.4.078.963.01 1.928-.008 2.892-.019 1.086-.013 2.172-.07 3.257-.039 1.445.042 2.853.325 4.16.968 1.561.769 2.742 1.94 3.547 3.483.514.985.812 2.03.931 3.14.172 1.608.059 3.179-.451 4.717-.632 1.906-1.832 3.365-3.499 4.458-1.283.841-2.69 1.338-4.198 1.622-1.596.301-3.197.204-4.798.209-1.756.007-3.511-.031-5.267-.051-.307-.003-.351-.061-.27-.354l.075-.27c.171-.538.263-.562.809-.652.378-.061.77-.203 1.087-.413.184-.122.26-.44.332-.685.062-.214.065-.449.067-.675.025-3.425.051-6.849.065-10.272.003-.865-.017-1.732-.065-2.596-.034-.605-.357-1.019-1.077-1.162-.56-.111-1.124-.197-1.687-.296zm16.076 8.293c-.076-.682-.113-1.37-.235-2.042-.292-1.613-.998-3.018-2.238-4.119-2.005-1.779-4.419-2.053-6.949-1.841-.576.048-.7.245-.709.837-.014.84-.028 1.68-.029 2.52-.004 2.664-.004 5.328 0 7.992.001.758.009 1.516.031 2.272.024.774.305 1.429 1.063 1.729 1.195.473 2.452.529 3.706.336 2.003-.307 3.404-1.474 4.344-3.223.744-1.388.954-2.903 1.016-4.461zm4.869 9.071c-.024-.415.146-.758.356-1.073.057-.085.253-.081.388-.108l1.146-.227c.405-.086.618-.358.675-.755.038-.262.074-.527.077-.792.025-2.097.049-4.194.059-6.291.01-2.1.002-4.2.002-6.3l-.009-.401c-.041-.675-.367-1.025-1.037-1.124l-1.453-.221c-.179-.024-.244-.11-.179-.269.112-.271.219-.552.377-.796.059-.09.258-.125.392-.122.694.01 1.388.062 2.082.061l6.041-.036c1.164-.001 2.288.202 3.332.759 1.149.612 1.792 1.559 1.976 2.849.192 1.355-.219 2.497-1.209 3.404-.407.374-.934.618-1.406.922l-.154.096c.438.161.855.3 1.261.466 1.188.487 2.133 1.248 2.633 2.463.395.959.395 1.959.161 2.953-.364 1.556-1.389 2.591-2.722 3.374-1.251.735-2.605 1.163-4.047 1.235-1.33.067-2.666.042-3.999.057l-.772.004c-1.284-.029-2.569-.062-3.854-.096zm5.537-6.089h.013c0 .658-.009 1.316.003 1.974.008.426-.007.864.085 1.274.138.613.418 1.166 1.106 1.342.929.239 1.878.287 2.818.124 1.177-.205 2.116-.795 2.631-1.916.382-.833.439-1.716.308-2.618-.174-1.188-.805-2.05-1.854-2.615-.688-.371-1.422-.598-2.204-.628-.876-.033-1.753-.035-2.629-.062-.246-.007-.28.118-.279.32.005.934.002 1.869.002 2.805zm1.865-4.475c.479-.024 1.021-.031 1.56-.085 1.032-.103 1.759-.622 2.138-1.609.193-.501.185-1.017.19-1.538.015-1.357-.777-2.469-2.066-2.929-.995-.355-2.021-.361-3.053-.333-.418.011-.605.194-.611.615l-.062 5.489c-.003.218.091.312.303.319z"
        fill="#94795d"
      />
      <path
        d="m10.543 116.448-.073.944c-.68 0-1.307-.005-1.934.002-1.181.012-2.362.031-3.544.048l-.114.007c-.169-.02-.476-.02-.484-.07-.05-.281-.034-.576-.021-.867.001-.033.116-.075.183-.091l.919-.205c.573-.149.775-.396.802-.988.031-.667.062-1.335.065-2.002.009-1.642-.001-3.282.006-4.924.001-.384-.132-.67-.49-.826-.426-.188-.854-.372-1.285-.546-.204-.082-.469-.127-.445-.401.024-.279.281-.352.523-.407 1.002-.229 2.005-.452 3.004-.696.322-.079.63-.212 1.015-.346.02.208.057.406.053.604l-.059.941c-.001.106.054.248.133.307.048.037.209-.03.289-.092.854-.65 1.758-1.211 2.789-1.538 1.597-.507 2.968-.037 3.928 1.34.338.485.339.485.808.146.805-.585 1.647-1.101 2.589-1.441 2.068-.747 4.055.201 4.774 2.284.262.756.362 1.537.36 2.335l-.019 5.298c-.001.437.144.686.56.822.467.153.951.258 1.477.396l-.122.911c-.598 0-1.148-.004-1.698.001-1.344.012-2.688.019-4.031.05-.234.006-.295-.052-.307-.271-.039-.701-.045-.7.615-.858l.222-.057c.645-.176.86-.374.865-1.028.015-1.878.054-3.761-.041-5.635-.099-1.944-1.642-2.979-3.526-2.481-.615.162-1.172.446-1.69.814-.175.125-.208.269-.194.488.053.828.086 1.657.093 2.486.012 1.451-.006 2.902 0 4.354.002.588.203.813.784.949l.863.199.16.036c.012.276.023.552.01.828-.008.173-.142.188-.292.185-.839-.021-1.679-.049-2.518-.047-1.021.002-2.041.031-3.061.049h-.24c0-.293-.014-.573.01-.852.005-.067.123-.161.204-.182l1.006-.213c.427-.105.631-.324.655-.758.114-2.01.196-4.021.007-6.03-.037-.39-.164-.786-.326-1.145-.515-1.138-1.674-1.613-3.011-1.271-.635.162-1.208.453-1.75.82-.256.174-.378.404-.378.695 0 2.005.007 4.01.013 6.014l.011.773c.012.539.241.823.776.939.344.078.692.131 1.082.203z"
        fill="#50382b"
      />
      <path
        d="m71.001 105.285c.155.754.152 1.432-.402 1.946-.55.511-1.246.339-1.925.225.063.358.133.662.167.97.247 2.289-.738 3.988-2.861 4.959-.802.366-1.653.502-2.522.572-.432.034-.81.364-.851.719-.042.36.184.73.636.838.533.127 1.089.163 1.636.226 1.174.134 2.361.195 3.521.405 1.754.316 2.733 1.847 2.424 3.609-.275 1.568-1.183 2.709-2.449 3.584-2.133 1.478-4.473 1.91-6.965 1.156-1.425-.432-2.43-1.369-2.777-2.885-.174-.759.011-1.446.582-1.961.679-.61 1.418-1.154 2.129-1.73l.23-.231-.264-.185c-.725-.344-1.305-.815-1.53-1.633-.077-.277.003-.459.238-.601.4-.241.798-.486 1.193-.735.186-.116.37-.236.543-.37.236-.18.215-.314-.067-.418-.656-.242-1.239-.593-1.691-1.133-.755-.901-.969-1.974-.907-3.107.097-1.77 1.058-2.936 2.62-3.686 1.857-.891 3.72-.947 5.613-.135.7.3 1.438.364 2.189.312.561-.04 1.051-.252 1.49-.711zm-6.843 12.681c-1.394-.012-1.831.16-2.649.993-.916.934-.911 2.229.003 3.167.694.711 1.56 1.044 2.523 1.144 1.125.116 2.233.069 3.255-.494 1.09-.603 1.632-1.723 1.387-2.851-.203-.931-.889-1.357-1.724-1.602-.95-.278-1.932-.331-2.795-.357zm-2.738-8.908c.051.387.072.779.158 1.158.223.982.65 1.845 1.627 2.282 1.147.515 2.612.294 3.114-1.316.344-1.103.302-2.198-.113-3.274-.185-.48-.483-.886-.91-1.184-.996-.695-2.793-.787-3.525.749-.238.499-.331 1.03-.351 1.585z"
        fill="#4f382b"
      />
      <path
        d="m47.35 105.038c.037.171.111.365.113.56.003.371-.037.742-.058 1.113v.322l.314-.24c.86-.708 1.784-1.311 2.86-1.636 1.942-.585 3.882.478 4.515 2.456.24.752.335 1.525.344 2.311.02 1.746.032 3.492.05 5.238.006.627.078.739.671.92.336.103.683.175 1.03.229.191.03.273.105.263.292l.002.172c-.007.723-.057.756-.758.754-1.678-.003-3.355.007-5.033.021-.5.004-.501.019-.551-.475l-.01-.284c.031-.426.041-.422.46-.484.282-.042.562-.107.837-.179.283-.073.419-.282.457-.562.019-.142.044-.284.043-.426-.024-1.908.007-3.818-.097-5.723-.084-1.541-1.26-2.459-2.807-2.354-.759.053-1.445.306-2.071.743-.413.289-.496.706-.494 1.155.008 1.784.025 3.568.044 5.353.004.391.015.782.052 1.17.039.424.188.595.604.687.398.088.804.139 1.229.21l.036.328c.014.765-.066.822-.809.819-1.735-.007-3.47.004-5.204.023-.273.004-.389-.082-.382-.348l-.004-.114c-.045-.689-.025-.715.627-.827l.308-.062c.706-.159.887-.347.897-1.064.033-2.271.045-4.541.068-6.812.003-.326-.12-.579-.424-.714-.426-.188-.856-.367-1.287-.544-.238-.098-.51-.16-.519-.489-.006-.232.242-.437.581-.506.681-.138 1.368-.253 2.041-.422.67-.167 1.328-.391 2.062-.611z"
        fill="#4f372b"
      />
      <path
        d="m84.865 110.97c-.032 2.121-.583 3.836-2.083 5.123-1.9 1.633-4.864 2.188-7.287.967-1.034-.521-1.794-1.32-2.289-2.357-.759-1.595-.949-3.272-.553-4.99.392-1.699 1.421-2.93 2.961-3.727 1.584-.819 3.252-1.139 5.011-.709 2.225.543 3.824 2.357 4.142 4.667.057.405.079.815.098 1.026zm-2.577 1.149-.086-.01c0-.2.011-.4-.002-.6-.073-1.246-.353-2.433-1.075-3.476-.685-.988-1.618-1.571-2.832-1.656-1.359-.096-2.501.664-2.902 2.052-.602 2.084-.398 4.115.66 6.024.461.832 1.144 1.446 2.059 1.769 1.793.631 3.383-.186 3.85-2.022.172-.678.222-1.387.328-2.081z"
        fill="#4f382b"
      />
      <path
        d="m40.819 111.134c-.037 1.522-.396 2.929-1.336 4.152-1.007 1.31-2.391 2.01-3.965 2.305-1.861.348-3.609.032-5.104-1.217-.71-.594-1.195-1.355-1.515-2.221-.525-1.42-.656-2.875-.333-4.358.345-1.587 1.241-2.8 2.63-3.614 1.606-.939 3.339-1.358 5.19-.936 2.38.544 3.754 2.095 4.262 4.443.102.474.116.964.171 1.446zm-2.606 1.004-.069-.01v-.286c-.039-1.396-.312-2.726-1.145-3.886-.617-.861-1.443-1.401-2.502-1.552-1.726-.246-2.854.778-3.228 2.169-.488 1.817-.335 3.612.42 5.335.471 1.074 1.215 1.911 2.358 2.317 1.782.633 3.396-.205 3.847-2.034.166-.669.216-1.367.319-2.053z"
        fill="#4f372b"
      />
      <path
        d="m82.362 33.544c1.227 3.547 2.109 7.168 2.4 10.92.36 4.656.196 9.28-.786 13.859l-.126.366c-.308.001-.622-.038-.923.009-2.543.4-5.083.814-7.624 1.226-2.627.426-5.256.835-7.878 1.289-.929.16-2.079-.031-2.454 1.253l-.18.061.127-7.678-.129-18.526 1.224-.21c2.001-.327 4.002-.66 6.006-.979 2.39-.379 4.782-.749 7.174-1.119 1.056-.162 2.113-.313 3.169-.471z"
        fill="#439934"
      />
      <path
        d="m62.265 84.911c-1.291-1.11-2.627-2.171-3.864-3.339-6.658-6.28-11.529-13.673-13.928-22.586-.661-2.452-1.101-4.945-1.243-7.479-.1-1.774-.243-3.563-.117-5.328.333-4.693 1.012-9.341 2.388-13.862l.076-.105c.134.178.326.336.394.537 1.344 3.956 2.677 7.916 4.004 11.879 4.169 12.451 8.333 24.905 12.509 37.354.082.243.293.442.445.661z"
        fill="#45a538"
      />
      <path
        d="m82.362 33.544c-1.057.157-2.114.309-3.169.471-2.392.37-4.784.74-7.174 1.119-2.003.318-4.004.651-6.006.979l-1.224.21-.01-.798c-.041-.656-.109-1.312-.118-1.968l-.137-12.554c-.032-2.619-.08-5.238-.133-7.856-.033-1.627-.068-3.255-.141-4.88-.04-.873-.181-1.742-.237-2.615-.033-.502.011-1.008.022-1.512.624 1.209 1.235 2.427 1.876 3.627 1.013 1.897 2.628 3.295 4.083 4.82 5.746 6.031 9.825 13.039 12.368 20.957z"
        fill="#46a037"
      />
      <path
        d="m64.792 62.527.18-.061c.375-1.284 1.525-1.093 2.454-1.253 2.622-.454 5.251-.863 7.878-1.289 2.541-.411 5.081-.825 7.624-1.226.301-.047.615-.008.923-.009-.475 1.696-.849 3.429-1.452 5.078-.685 1.87-1.513 3.696-2.392 5.486-1.314 2.675-2.951 5.171-4.853 7.458-1.466 1.762-3.1 3.393-4.737 5.002-.906.889-1.972 1.614-2.966 2.414l-.258-.176-.927-.792-.959-2.104c-.661-2.462-1.007-4.968-1.065-7.516l.018-.428.131-1.854c.043-.633.101-1.265.128-1.898.096-2.276.182-4.554.273-6.832z"
        fill="#409433"
      />
      <path
        d="m64.792 62.527c-.09 2.278-.176 4.557-.273 6.835-.027.634-.084 1.266-.128 1.898l-.584.221c-1.298-3.821-2.597-7.602-3.867-11.392-2.101-6.271-4.176-12.551-6.274-18.824-1.693-5.062-3.401-10.121-5.118-15.176-.081-.236-.311-.422-.471-.631l3.74-6.877c.129.223.298.432.379.672 1.73 5.12 3.457 10.241 5.169 15.367 2.228 6.67 4.441 13.343 6.667 20.014.089.266.235.512.375.811l.512-.596c-.043 2.56-.085 5.118-.127 7.678z"
        fill="#4faa41"
      />
      <path
        d="m48.076 25.458c.161.209.391.395.471.631 1.717 5.055 3.425 10.113 5.118 15.176 2.098 6.273 4.173 12.553 6.274 18.824 1.27 3.79 2.569 7.57 3.867 11.392l.584-.221-.131 1.854-.119.427c-.203 2.029-.374 4.062-.622 6.087-.124 1.015-.389 2.011-.59 3.015-.151-.219-.363-.418-.445-.661-4.177-12.449-8.34-24.903-12.509-37.354-1.327-3.963-2.661-7.923-4.004-11.879-.068-.201-.26-.359-.394-.537z"
        fill="#4aa73c"
      />
      <path
        d="m64.918 54.849-.512.596c-.14-.299-.286-.545-.375-.811-2.226-6.671-4.439-13.344-6.667-20.014-1.712-5.126-3.439-10.247-5.169-15.367-.081-.24-.25-.449-.379-.672l4.625-6.084c.146.194.354.367.429.586 1.284 3.76 2.556 7.523 3.822 11.289 1.182 3.518 2.346 7.04 3.542 10.552.08.235.359.401.545.601l.01.798z"
        fill="#57ae47"
      />
      <path
        d="m64.779 35.525c-.187-.199-.465-.365-.545-.601-1.195-3.512-2.36-7.034-3.542-10.552-1.266-3.766-2.538-7.529-3.822-11.289-.075-.219-.283-.392-.429-.586 1.504-1.473 2.961-2.999 4.526-4.404 1.391-1.248 2.509-2.586 2.561-4.559l.11-.393.396.998c-.01.504-.055 1.01-.022 1.512.057.873.198 1.742.237 2.615.073 1.625.108 3.253.141 4.88.053 2.618.101 5.237.133 7.856l.137 12.554c.01.657.079 1.313.119 1.969z"
        fill="#60b24f"
      />
      <path
        d="m62.929 82.642c.201-1.004.466-2 .59-3.015.248-2.024.419-4.058.622-6.087l.051-.008.05.009c.058 2.548.404 5.054 1.065 7.516-.135.178-.324.335-.396.535-.555 1.566-1.079 3.145-1.637 4.71-.076.214-.29.381-.439.568l-.571-1.96z"
        fill="#a9aa88"
      />
      <path
        d="m62.835 86.871c.149-.188.363-.354.439-.568.558-1.565 1.082-3.144 1.637-4.71.071-.2.261-.357.396-.535l.959 2.104c-.189.268-.451.511-.556.81l-1.836 5.392c-.076.217-.333.369-.507.552z"
        fill="#b6b598"
      />
      <path
        d="m63.367 89.915c.173-.183.431-.335.507-.552l1.836-5.392c.104-.299.367-.542.556-.81l.928.791c-.448.443-.697.955-.547 1.602l-.282.923c-.128.158-.314.296-.377.477-.641 1.836-1.252 3.682-1.898 5.517-.082.232-.309.415-.468.621z"
        fill="#c2c1a7"
      />
      <path
        d="m63.621 93.091c.16-.206.387-.389.468-.621.646-1.835 1.258-3.681 1.898-5.517.063-.181.249-.318.377-.477l-.389 4.236c-.104.12-.254.225-.304.364l-1.294 3.708c-.091.253-.265.479-.401.716-.121-.158-.337-.311-.347-.475-.038-.642-.011-1.289-.008-1.934z"
        fill="#cecdb7"
      />
      <path
        d="m63.977 95.501c.136-.237.31-.463.401-.716l1.294-3.708c.05-.14.201-.244.304-.364l.01 2.78-.931 2.387z"
        fill="#dbdac7"
      />
      <path d="m65.055 95.88.931-2.387.192 2.824z" fill="#ebe9dc" />
      <path
        d="m66.646 85.554c-.149-.646.099-1.158.547-1.602l.258.176z"
        fill="#cecdb7"
      />
      <path d="m64.242 73.542-.05-.009-.051.008.119-.427z" fill="#4faa41" />
    </g>
  </svg>
);

export const ExpressIcon = ({ width, height, logoFill }) => (
  <svg
    width={width || '48'}
    height={height || '48'}
    viewBox="0 -191.5 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <g>
      <path
        d="M3.33224862,115.629027 L3.33224862,58.6475756 L74.4757566,58.6475756 L74.4757566,55.315327 L3.33224862,55.315327 L3.33224862,3.33224862 L78.9742922,3.33224862 L78.9742922,0 L-3.55271368e-15,0 L-3.55271368e-15,118.961276 L79.640742,118.961276 L79.640742,115.629027 L3.33224862,115.629027 L3.33224862,115.629027 Z M143.786528,33.3224862 L114.296128,72.1431826 L85.472177,33.3224862 L81.1402538,33.3224862 L112.296778,74.642369 L78.14123,118.961276 L82.1399284,118.961276 L114.296128,77.1415554 L146.618939,118.961276 L150.78425,118.961276 L116.462089,74.642369 L147.785226,33.3224862 L143.786528,33.3224862 L143.786528,33.3224862 Z M160.780996,148.285063 L160.780996,94.9690856 L161.114221,94.9690856 C163.11358,102.744371 167.056701,108.992275 172.943703,113.712984 C178.830705,118.433693 186.32819,120.794012 195.436381,120.794012 C201.323384,120.794012 206.543854,119.599969 211.09795,117.211845 C215.652046,114.823722 219.456324,111.574812 222.510902,107.465018 C225.565478,103.355224 227.898028,98.5790488 229.508624,93.1363488 C231.119218,87.6936488 231.924504,81.973346 231.924504,75.9752684 C231.924504,69.532889 231.09145,63.5904384 229.425318,58.1477384 C227.759184,52.7050384 225.343328,47.9844 222.177676,43.9856818 C219.012024,39.9869634 215.179976,36.8768958 210.681418,34.6553856 C206.18286,32.4338754 201.101232,31.323137 195.436381,31.323137 C191.104437,31.323137 187.07801,31.9618116 183.35698,33.23918 C179.635951,34.5165484 176.331504,36.3214982 173.443541,38.654084 C170.555577,40.9866696 168.056416,43.7357472 165.945981,46.9013992 C163.835546,50.0670512 162.224976,53.5381088 161.114221,57.3146762 L160.780996,57.3146762 L160.780996,33.3224862 L157.448747,33.3224862 L157.448747,148.285063 L160.780996,148.285063 L160.780996,148.285063 Z M195.436381,117.628376 C184.995284,117.628376 176.609208,114.046245 170.277904,106.881874 C163.9466,99.717504 160.780996,89.415405 160.780996,75.9752684 C160.780996,70.421493 161.558513,65.1454854 163.11357,60.1470876 C164.668627,55.1486896 166.917872,50.7612728 169.861373,46.9847054 C172.804874,43.2081382 176.442543,40.2091444 180.774487,37.9876342 C185.106432,35.766124 189.993681,34.6553856 195.436381,34.6553856 C200.990156,34.6553856 205.849638,35.766124 210.01497,37.9876342 C214.1803,40.2091444 217.62359,43.2359066 220.34494,47.0680118 C223.06629,50.9001168 225.121156,55.2875336 226.5096,60.2303938 C227.898044,65.173254 228.592256,70.421493 228.592256,75.9752684 C228.592256,80.9736664 227.95358,85.9442208 226.676212,90.887081 C225.398844,95.8299412 223.427284,100.272895 220.76147,104.216075 C218.095658,108.159256 214.680138,111.380398 210.514806,113.879596 C206.349474,116.378795 201.323384,117.628376 195.436381,117.628376 L195.436381,117.628376 L195.436381,117.628376 Z M250.251872,118.961276 L250.251872,70.4770582 C250.251872,65.8118868 250.918314,61.2578592 252.25122,56.814839 C253.584126,52.3718186 255.638992,48.4564656 258.41588,45.0686626 C261.192768,41.6808596 264.719362,39.0150872 268.99577,37.0712658 C273.272176,35.1274444 278.353806,34.322159 284.240808,34.6553856 L284.240808,31.323137 C279.131334,31.2120614 274.660612,31.7674308 270.828506,32.9892614 C266.996402,34.211092 263.691954,35.8771996 260.915066,37.9876342 C258.138178,40.098069 255.916702,42.569462 254.25057,45.4018874 C252.584436,48.2343128 251.362624,51.2610752 250.585096,54.4822648 L250.251872,54.4822648 L250.251872,33.3224862 L246.919622,33.3224862 L246.919622,118.961276 L250.251872,118.961276 L250.251872,118.961276 Z M288.406118,76.8083306 L360.049464,76.8083306 C360.271614,70.9213286 359.688476,65.2565626 358.300032,59.8138626 C356.911588,54.3711628 354.690112,49.5394506 351.635536,45.3185812 C348.580958,41.0977118 344.637838,37.7099596 339.806052,35.155223 C334.974268,32.6004862 329.226196,31.323137 322.561666,31.323137 C317.78542,31.323137 313.120318,32.3228016 308.566222,34.3221608 C304.012126,36.32152 300.013468,39.2372084 296.570126,43.0693134 C293.126786,46.9014184 290.34994,51.5942884 288.239506,57.1480638 C286.12907,62.7018392 285.07387,69.0330484 285.07387,76.1418808 C285.07387,82.473185 285.79585,88.387867 287.23983,93.8861048 C288.683812,99.3843424 290.90529,104.160518 293.904328,108.214774 C296.903366,112.26903 300.763182,115.406866 305.483892,117.628376 C310.204602,119.849886 315.897136,120.905088 322.561666,120.794012 C332.33631,120.794012 340.555776,118.044935 347.220306,112.546697 C353.884836,107.048459 357.827958,99.3010588 359.049788,89.304263 L355.71754,89.304263 C354.273558,98.7456812 350.580352,105.826639 344.637814,110.547348 C338.695274,115.268057 331.225558,117.628376 322.228442,117.628376 C316.119288,117.628376 310.954354,116.573175 306.733486,114.46274 C302.512616,112.352305 299.069326,109.464385 296.403514,105.798894 C293.737702,102.133402 291.766142,97.8292904 290.488774,92.8864302 C289.211404,87.94357 288.517194,82.5842572 288.406118,76.8083306 L288.406118,76.8083306 L288.406118,76.8083306 Z M356.717214,73.476082 L288.406118,73.476082 C288.739344,67.4780046 289.850082,62.0909232 291.738366,57.3146762 C293.62665,52.5384294 296.098044,48.4564656 299.15262,45.0686626 C302.207196,41.6808596 305.76156,39.0983926 309.815816,37.3211846 C313.870072,35.5439764 318.22972,34.6553856 322.89489,34.6553856 C328.448666,34.6553856 333.335916,35.6828186 337.556784,37.7377156 C341.777654,39.7926126 345.304248,42.597227 348.136674,46.1516434 C350.9691,49.7060596 353.107272,53.8435602 354.551252,58.5642694 C355.995234,63.2849786 356.717214,68.255533 356.717214,73.476082 L356.717214,73.476082 L356.717214,73.476082 Z M429.193622,58.6475756 L432.52587,58.6475756 C432.52587,49.0950818 429.749024,42.1529666 424.195248,37.8210218 C418.641474,33.489077 411.088452,31.323137 401.535958,31.323137 C396.204334,31.323137 391.705844,31.98958 388.040352,33.3224862 C384.37486,34.6553922 381.375866,36.3770368 379.04328,38.4874716 C376.710694,40.5979062 375.044586,42.930457 374.044908,45.4851936 C373.045228,48.0399304 372.545396,50.4835548 372.545396,52.8161406 C372.545396,57.481312 373.37845,61.2022858 375.044582,63.9791734 C376.710714,66.7560612 379.32095,68.9220012 382.875366,70.4770582 C385.319028,71.5878134 388.095874,72.587478 391.205988,73.476082 C394.316102,74.364686 397.926002,75.3088138 402.035796,76.3084934 C405.701288,77.1970974 409.311188,78.0856882 412.865604,78.9742922 C416.42002,79.8628962 419.557856,81.0569402 422.279206,82.5564594 C425.000556,84.0559788 427.222032,85.9720026 428.943704,88.3045884 C430.665374,90.637174 431.526196,93.6917048 431.526196,97.468272 C431.526196,101.133764 430.665374,104.243831 428.943704,106.798568 C427.222032,109.353305 425.028324,111.435939 422.362512,113.046534 C419.6967,114.657129 416.725474,115.823405 413.448748,116.545395 C410.17202,117.267386 406.978646,117.628376 403.868532,117.628376 C393.760662,117.628376 386.01326,115.379131 380.626098,110.880573 C375.238936,106.382015 372.545396,99.3010572 372.545396,89.6374878 L369.213146,89.6374878 C369.213146,100.411812 372.128836,108.298055 377.9603,113.296453 C383.791764,118.294851 392.427754,120.794012 403.868532,120.794012 C407.534024,120.794012 411.22723,120.377485 414.94826,119.544419 C418.669288,118.711353 422.001504,117.350698 424.945004,115.462415 C427.888506,113.574131 430.276594,111.130506 432.10934,108.131468 C433.942086,105.132429 434.858444,101.466992 434.858444,97.1350472 C434.858444,93.0252534 434.05316,89.693038 432.442564,87.1383014 C430.83197,84.5835646 428.721566,82.4731616 426.111292,80.807029 C423.501018,79.1408964 420.55756,77.8357786 417.280834,76.8916368 C414.004106,75.947495 410.699658,75.0311358 407.367394,74.1425318 C402.702222,72.9207012 398.620258,71.8654996 395.12138,70.9768956 C391.622502,70.0882914 388.373592,69.03309 385.374552,67.8112594 C382.48659,66.5894288 380.181808,64.8400158 378.460136,62.5629678 C376.738466,60.2859198 375.877644,57.03701 375.877644,52.8161406 C375.877644,52.038612 376.099792,50.650189 376.544094,48.6508298 C376.988396,46.6514706 378.043598,44.624373 379.70973,42.569476 C381.375862,40.5145792 383.93056,38.6818608 387.373902,37.0712658 C390.817242,35.460671 395.53788,34.6553856 401.535958,34.6553856 C405.645752,34.6553856 409.394494,35.099681 412.782298,35.988285 C416.1701,36.8768892 419.085788,38.2930806 421.52945,40.236902 C423.973112,42.1807234 425.861366,44.6521164 427.194272,47.6511552 C428.527178,50.650194 429.193622,54.3156308 429.193622,58.6475756 L429.193622,58.6475756 L429.193622,58.6475756 Z M506.335178,58.6475756 L509.667426,58.6475756 C509.667426,49.0950818 506.89058,42.1529666 501.336804,37.8210218 C495.783028,33.489077 488.230008,31.323137 478.677514,31.323137 C473.34589,31.323137 468.847398,31.98958 465.181906,33.3224862 C461.516416,34.6553922 458.517422,36.3770368 456.184836,38.4874716 C453.85225,40.5979062 452.186142,42.930457 451.186462,45.4851936 C450.186784,48.0399304 449.68695,50.4835548 449.68695,52.8161406 C449.68695,57.481312 450.520004,61.2022858 452.186138,63.9791734 C453.85227,66.7560612 456.462506,68.9220012 460.016922,70.4770582 C462.460582,71.5878134 465.237428,72.587478 468.347544,73.476082 C471.457658,74.364686 475.067558,75.3088138 479.177352,76.3084934 C482.842842,77.1970974 486.452742,78.0856882 490.00716,78.9742922 C493.561576,79.8628962 496.699412,81.0569402 499.420762,82.5564594 C502.142112,84.0559788 504.363588,85.9720026 506.085258,88.3045884 C507.80693,90.637174 508.667752,93.6917048 508.667752,97.468272 C508.667752,101.133764 507.80693,104.243831 506.085258,106.798568 C504.363588,109.353305 502.16988,111.435939 499.504068,113.046534 C496.838256,114.657129 493.86703,115.823405 490.590302,116.545395 C487.313576,117.267386 484.120202,117.628376 481.010088,117.628376 C470.902216,117.628376 463.154816,115.379131 457.767654,110.880573 C452.380492,106.382015 449.68695,99.3010572 449.68695,89.6374878 L446.354702,89.6374878 C446.354702,100.411812 449.27039,108.298055 455.101854,113.296453 C460.93332,118.294851 469.56931,120.794012 481.010088,120.794012 C484.67558,120.794012 488.368784,120.377485 492.089814,119.544419 C495.810844,118.711353 499.14306,117.350698 502.08656,115.462415 C505.030062,113.574131 507.418148,111.130506 509.250894,108.131468 C511.08364,105.132429 512,101.466992 512,97.1350472 C512,93.0252534 511.194714,89.693038 509.58412,87.1383014 C507.973524,84.5835646 505.863122,82.4731616 503.252848,80.807029 C500.642572,79.1408964 497.699116,77.8357786 494.422388,76.8916368 C491.145662,75.947495 487.841214,75.0311358 484.508948,74.1425318 C479.843778,72.9207012 475.761814,71.8654996 472.262936,70.9768956 C468.764056,70.0882914 465.515146,69.03309 462.516108,67.8112594 C459.628144,66.5894288 457.323362,64.8400158 455.601692,62.5629678 C453.880022,60.2859198 453.0192,57.03701 453.0192,52.8161406 C453.0192,52.038612 453.241348,50.650189 453.68565,48.6508298 C454.129952,46.6514706 455.185152,44.624373 456.851286,42.569476 C458.517418,40.5145792 461.072116,38.6818608 464.515458,37.0712658 C467.958798,35.460671 472.679436,34.6553856 478.677514,34.6553856 C482.787308,34.6553856 486.53605,35.099681 489.923852,35.988285 C493.311656,36.8768892 496.227344,38.2930806 498.671006,40.236902 C501.114666,42.1807234 503.002922,44.6521164 504.335828,47.6511552 C505.668734,50.650194 506.335178,54.3156308 506.335178,58.6475756 L506.335178,58.6475756 L506.335178,58.6475756 Z"
        fill={logoFill || '#fff'}
      ></path>
    </g>
  </svg>
);

export const EJSIcon = ({ width, height, logoFill }) => (
  <svg
    width={width || '48'}
    height={height || '48'}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>file_type_ejs</title>
    <path
      d="M2,17.672V14.328l11.86-6.2V11.2L5.1,15.939l8.762,4.835v3.1Zm27.814-8.88L19.465,23.229H15.912L26.281,8.791ZM26.947,21.5a.794.794,0,0,0,.619-.278,1.061,1.061,0,0,0,.248-.732,1.141,1.141,0,0,0-.248-.753.768.768,0,0,0-1.217,0,1.141,1.141,0,0,0-.248.753,1.09,1.09,0,0,0,.237.732A.763.763,0,0,0,26.947,21.5Zm2.186,1.042a3.237,3.237,0,0,1-4.352-.01,2.864,2.864,0,0,1,0-4.1,3.223,3.223,0,0,1,4.352,0A2.773,2.773,0,0,1,30,20.486,2.74,2.74,0,0,1,29.134,22.538ZM18.821,13.061a.794.794,0,0,0,.619-.278,1.061,1.061,0,0,0,.248-.732,1.141,1.141,0,0,0-.248-.753.769.769,0,0,0-1.217,0,1.141,1.141,0,0,0-.248.753,1.09,1.09,0,0,0,.237.732A.763.763,0,0,0,18.821,13.061ZM21.007,14.1a3.237,3.237,0,0,1-4.352-.01,2.864,2.864,0,0,1,0-4.1,3.223,3.223,0,0,1,4.352,0,2.773,2.773,0,0,1,.866,2.063A2.74,2.74,0,0,1,21.007,14.1Z"
      fill={logoFill || '#ffff'}
    />
  </svg>
);

export const NodeJSIcon = ({ width, height, logoFill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width={width || '48'}
    height={height || '48'}
  >
    <path
      fill={logoFill || '#ffff'}
      d="M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4 .1l14.8 8.8c.5 .3 1.3 .3 1.8 0L375 408c.5-.3 .9-.9 .9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6 .3-.9 1-.9 1.6v66.7c0 .6 .4 1.2 .9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9 .7-1.7 1.7-1.7h7.3c.9 0 1.7 .7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6 .2 .8 .8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5 .3-.4 .5-.8 .4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7 .7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7 .1 1.8 1.2 2.1 2.8 .1 1 .3 2.7 .6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3 .4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3 .7 2.5 1.8 3.2 1.1 .7 2.5 .7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6 .3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1 .7 2.6 .7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6 .3-.9 .9-.9 1.6v24.3c0 .7 .4 1.3 .9 1.6l21 12.1c.6 .3 1.3 .3 1.8 0l21-12.1c.6-.3 .9-.9 .9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3 .7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1 .7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4 .3-.7 .7-.7 1.2v13.6c0 .5 .3 1 .7 1.2l11.8 6.8c.4 .3 1 .3 1.4 0L584 235c.4-.3 .7-.7 .7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7 .1-.5 .2-1.1 .2-1.7zm-74.3-124.9l-.8 .5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
    />
  </svg>
);

export const PostregSQLIcon = ({ width, height, logoFill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25.6 25.6"
    width={width || '48'}
    height={height || '48'}
  >
    <g fill="none" stroke="#fff">
      <path
        d="M18.983 18.636c.163-1.357.114-1.555 1.124-1.336l.257.023c.777.035 1.793-.125 2.4-.402 1.285-.596 2.047-1.592.78-1.33-2.89.596-3.1-.383-3.1-.383 3.053-4.53 4.33-10.28 3.227-11.687-3.004-3.84-8.205-2.024-8.292-1.976l-.028.005c-.57-.12-1.2-.19-1.93-.2-1.308-.02-2.3.343-3.054.914 0 0-9.277-3.822-8.846 4.807.092 1.836 2.63 13.9 5.66 10.25C8.29 15.987 9.36 14.86 9.36 14.86c.53.353 1.167.533 1.834.468l.052-.044a2.01 2.01 0 0 0 .021.518c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.162l-.046.183c.306.245.285 1.76.33 2.842s.116 2.093.337 2.688.48 2.13 2.53 1.7c1.713-.367 3.023-.896 3.143-5.81"
        fill="#000"
        stroke="#000"
        strokeLinecap="butt"
        strokeWidth="2.149"
        class="D"
      />
      <path
        d="M23.535 15.6c-2.89.596-3.1-.383-3.1-.383 3.053-4.53 4.33-10.28 3.228-11.687-3.004-3.84-8.205-2.023-8.292-1.976l-.028.005a10.31 10.31 0 0 0-1.929-.201c-1.308-.02-2.3.343-3.054.914 0 0-9.278-3.822-8.846 4.807.092 1.836 2.63 13.9 5.66 10.25C8.29 15.987 9.36 14.86 9.36 14.86c.53.353 1.167.533 1.834.468l.052-.044a2.02 2.02 0 0 0 .021.518c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.162l-.046.183c.306.245.52 1.593.484 2.815s-.06 2.06.18 2.716.48 2.13 2.53 1.7c1.713-.367 2.6-1.32 2.725-2.906.088-1.128.286-.962.3-1.97l.16-.478c.183-1.53.03-2.023 1.085-1.793l.257.023c.777.035 1.794-.125 2.39-.402 1.285-.596 2.047-1.592.78-1.33z"
        fill="#336791"
        stroke="none"
      />
      <g class="E">
        <g class="B">
          <path
            d="M12.814 16.467c-.08 2.846.02 5.712.298 6.4s.875 2.05 2.926 1.612c1.713-.367 2.337-1.078 2.607-2.647l.633-5.017M10.356 2.2S1.072-1.596 1.504 7.033c.092 1.836 2.63 13.9 5.66 10.25C8.27 15.95 9.27 14.907 9.27 14.907m6.1-13.4c-.32.1 5.164-2.005 8.282 1.978 1.1 1.407-.175 7.157-3.228 11.687"
            class="C"
          />
          <path
            d="M20.425 15.17s.2.98 3.1.382c1.267-.262.504.734-.78 1.33-1.054.49-3.418.615-3.457-.06-.1-1.745 1.244-1.215 1.147-1.652-.088-.394-.69-.78-1.086-1.744-.347-.84-4.76-7.29 1.224-6.333.22-.045-1.56-5.7-7.16-5.782S7.99 8.196 7.99 8.196"
            strokeLinejoin="bevel"
          />
        </g>
        <g class="C">
          <path d="M11.247 15.768c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.163.35-.49-.002-1.27-.482-1.468-.232-.096-.542-.216-.94.23z" />
          <path
            d="M11.196 15.753c-.08-.513.168-1.122.433-1.836.398-1.07 1.316-2.14.582-5.537-.547-2.53-4.22-.527-4.22-.184s.166 1.74-.06 3.365c-.297 2.122 1.35 3.916 3.246 3.733"
            class="B"
          />
        </g>
      </g>
      <g fill="#fff" class="D">
        <path
          d="M10.322 8.145c-.017.117.215.43.516.472s.558-.202.575-.32-.215-.246-.516-.288-.56.02-.575.136z"
          strokeWidth=".239"
        />
        <path
          d="M19.486 7.906c.016.117-.215.43-.516.472s-.56-.202-.575-.32.215-.246.516-.288.56.02.575.136z"
          strokeWidth=".119"
        />
      </g>
      <path
        d="M20.562 7.095c.05.92-.198 1.545-.23 2.524-.046 1.422.678 3.05-.413 4.68"
        class="B C E"
      />
    </g>
  </svg>
);

export const PythonIcon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width || '48'}
    height={height || '48'}
  >
    <path
      fill="#0277BD"
      d="M24.047,5c-1.555,0.005-2.633,0.142-3.936,0.367c-3.848,0.67-4.549,2.077-4.549,4.67V14h9v2H15.22h-4.35c-2.636,0-4.943,1.242-5.674,4.219c-0.826,3.417-0.863,5.557,0,9.125C5.851,32.005,7.294,34,9.931,34h3.632v-5.104c0-2.966,2.686-5.896,5.764-5.896h7.236c2.523,0,5-1.862,5-4.377v-8.586c0-2.439-1.759-4.263-4.218-4.672C27.406,5.359,25.589,4.994,24.047,5z M19.063,9c0.821,0,1.5,0.677,1.5,1.502c0,0.833-0.679,1.498-1.5,1.498c-0.837,0-1.5-0.664-1.5-1.498C17.563,9.68,18.226,9,19.063,9z"
    />
    <path
      fill="#FFC107"
      d="M23.078,43c1.555-0.005,2.633-0.142,3.936-0.367c3.848-0.67,4.549-2.077,4.549-4.67V34h-9v-2h9.343h4.35c2.636,0,4.943-1.242,5.674-4.219c0.826-3.417,0.863-5.557,0-9.125C41.274,15.995,39.831,14,37.194,14h-3.632v5.104c0,2.966-2.686,5.896-5.764,5.896h-7.236c-2.523,0-5,1.862-5,4.377v8.586c0,2.439,1.759,4.263,4.218,4.672C19.719,42.641,21.536,43.006,23.078,43z M28.063,39c-0.821,0-1.5-0.677-1.5-1.502c0-0.833,0.679-1.498,1.5-1.498c0.837,0,1.5,0.664,1.5,1.498C29.563,38.32,28.899,39,28.063,39z"
    />
  </svg>
);

export const DjangoIcon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    width={width || '48'}
    height={height || '48'}
  >
    <path
      fill="#138449"
      d="M50,24.939C50,28.564,47.573,31,43.961,31c-1.332,0-2.499-0.333-3.441-0.934c-0.151,0.843-0.414,1.576-0.867,2.258 C38.847,33.545,37.197,35,33.909,35c-1.244,0-2.332-0.192-3.423-0.605l-1.292-0.489V31c0,0-10.791,0-11.29,0 c-0.966,0-1.734-0.148-2.36-0.384c-0.099,0.29-0.208,0.573-0.352,0.846c-0.618,1.2-1.471,1.988-2.945,2.721l-0.867,0.431 l-0.876-0.413L8.169,33.1l-5.267-2.924l0.011-0.001C1.047,29.198,0,27.392,0,24.944c0-3.413,2.25-5.869,5.561-6.197V17v-2h10.456v2 v2.397C16.874,19.14,17.747,19,18.662,19c1.366,0,2.313,0.329,2.983,0.772l0.528-0.144C23.764,19.194,25.077,19,26.431,19 c1.788,0,3.16,0.497,4.081,1.479c0.132,0.141,0.247,0.284,0.353,0.43C32.094,19.77,33.992,19,36.758,19 c1.188,0,2.322,0.119,3.677,0.387l0.877,0.173C42.116,19.2,43.038,19,44.059,19C47.612,19,50,21.387,50,24.939z M7.561,17v3.839 c-0.376-0.097-0.825-0.13-1.233-0.13C3.697,20.709,2,22.376,2,24.944C2,27.609,3.6,28.997,6.675,29 c1.027,0,2.036-0.097,3.325-0.343V17H7.561L7.561,17z M7.561,22.865v4.044c-0.36,0.049-0.724,0.065-1.003,0.065 c-1.289,0-1.992-0.739-1.992-2.078c0-1.375,0.735-2.16,2.008-2.16C6.885,22.736,7.266,22.768,7.561,22.865L7.561,22.865z M11.487,21v4.916c0,2.169-0.113,2.994-0.473,3.706c-0.343,0.696-0.881,1.153-1.992,1.669l2.336,1.101 c1.111-0.552,1.649-1.052,2.057-1.845C13.852,29.722,14,28.765,14,26.776V21H11.487z M11.5,19.558h2.517V17H11.5V19.558z M15.496,23.596c0.933-0.486,1.928-0.739,2.812-0.739c0.604,0,0.822,0.159,0.822,0.598v0.533c-2.935,0.25-4.13,1.035-4.13,2.734 C15,28.293,15.899,29,17.904,29c0.992,0,2.344-0.112,3.416-0.268v-4.918c0-1.007-0.065-1.477-0.265-1.839 C20.698,21.33,19.891,21,18.662,21c-1.103,0-2.113,0.221-3.169,0.723L15.496,23.596z M19.237,25.572v1.621 c-0.465,0.078-0.791,0.109-1.148,0.109c-0.653,0-0.949-0.221-0.949-0.692C17.14,25.98,17.655,25.728,19.237,25.572L19.237,25.572z M22.7,29H25v-5.843c0.477-0.146,0.843-0.177,1.168-0.177c0.847,0,1.243,0.352,1.243,1.295V29h2.29v-4.823 c0-1.229-0.157-1.805-0.649-2.331C28.529,21.288,27.648,21,26.431,21c-1.171,0-2.327,0.174-3.731,0.557V29z M31.195,30.268v2.256 C32.077,32.858,32.927,33,33.909,33c1.931,0,3.29-0.589,4.075-1.778c0.538-0.812,0.72-1.794,0.72-3.889v-0.667 c-0.017-0.334-0.017-0.667-0.033-1.001l-0.016-1.334L38.623,23.3v-0.255c0.506,0.047-0.11-0.06,0.561,0.066l0.863-1.762 C38.837,21.11,37.838,21,36.758,21C33.079,21,31,22.57,31,25.348c0,2.237,1.405,3.65,3.613,3.65c0.652,0,1.145-0.098,1.635-0.334 v0.047c0,1.554-0.704,2.206-2.355,2.206C32.959,30.917,32.077,30.712,31.195,30.268L31.195,30.268z M36.2,23.158l0.017,0.809 l0.016,1.126c0,0.334,0.017,0.651,0.017,0.938v0.667v0.177c-0.324,0.095-0.604,0.157-0.947,0.157c-1.113,0-1.735-0.699-1.735-1.919 c0-0.856,0.311-1.46,0.914-1.793c0.393-0.239,0.967-0.365,1.457-0.349h0.182H36.2V23.158z M40,25.077 C40,27.497,41.511,29,43.961,29C46.443,29,48,27.435,48,24.939C48,22.504,46.505,21,44.059,21C41.561,21,40.004,22.565,40,25.077z M44.008,27.075c-0.952,0-1.511-0.759-1.511-2.078c0-1.319,0.556-2.078,1.527-2.078c0.939,0,1.478,0.775,1.478,2.078 C45.503,26.316,44.948,27.075,44.008,27.075L44.008,27.075z"
    />
  </svg>
);

export const LinkedInIcon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width || '48'}
    height={height || '48'}
  >
    <path
      fill="#0288D1"
      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
    />
    <path
      fill="#FFF"
      d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
    />
  </svg>
);

export const GitHubIcon = ({ width, height, logoFill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width || '48'}
    height={height || '48'}
  >
    {' '}
    <path
      fill={logoFill}
      d="M10.9,2.1c-4.6,0.5-8.3,4.2-8.8,8.7c-0.5,4.7,2.2,8.9,6.3,10.5C8.7,21.4,9,21.2,9,20.8v-1.6c0,0-0.4,0.1-0.9,0.1 c-1.4,0-2-1.2-2.1-1.9c-0.1-0.4-0.3-0.7-0.6-1C5.1,16.3,5,16.3,5,16.2C5,16,5.3,16,5.4,16c0.6,0,1.1,0.7,1.3,1c0.5,0.8,1.1,1,1.4,1 c0.4,0,0.7-0.1,0.9-0.2c0.1-0.7,0.4-1.4,1-1.8c-2.3-0.5-4-1.8-4-4c0-1.1,0.5-2.2,1.2-3C7.1,8.8,7,8.3,7,7.6C7,7.2,7,6.6,7.3,6 c0,0,1.4,0,2.8,1.3C10.6,7.1,11.3,7,12,7s1.4,0.1,2,0.3C15.3,6,16.8,6,16.8,6C17,6.6,17,7.2,17,7.6c0,0.8-0.1,1.2-0.2,1.4 c0.7,0.8,1.2,1.8,1.2,3c0,2.2-1.7,3.5-4,4c0.6,0.5,1,1.4,1,2.3v2.6c0,0.3,0.3,0.6,0.7,0.5c3.7-1.5,6.3-5.1,6.3-9.3 C22,6.1,16.9,1.4,10.9,2.1z"
    />
  </svg>
);

export const GmailIcon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width || '48'}
    height={height || '48'}
  >
    <path
      fill="#4caf50"
      d="M45,16.2l-5,2.75l-5,4.75L35,40h7c1.657,0,3-1.343,3-3V16.2z"
    />
    <path
      fill="#1e88e5"
      d="M3,16.2l3.614,1.71L13,23.7V40H6c-1.657,0-3-1.343-3-3V16.2z"
    />
    <polygon
      fill="#e53935"
      points="35,11.2 24,19.45 13,11.2 12,17 13,23.7 24,31.95 35,23.7 36,17"
    />
    <path
      fill="#c62828"
      d="M3,12.298V16.2l10,7.5V11.2L9.876,8.859C9.132,8.301,8.228,8,7.298,8h0C4.924,8,3,9.924,3,12.298z"
    />
    <path
      fill="#fbc02d"
      d="M45,12.298V16.2l-10,7.5V11.2l3.124-2.341C38.868,8.301,39.772,8,40.702,8h0 C43.076,8,45,9.924,45,12.298z"
    />
  </svg>
);

export const UpIcon = ({ width, height, backgroundFill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z" />
  </svg>
);

export const Ptag = ({ width, height, letterFill }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width || '48'}
    height={height || '48'}
    viewBox="0 0 270 129"
    enableBackground="new 0 0 270 129"
  >
    <path
      fill="#252521" // background
      opacity="0.01"
      stroke="none"
      d="
M210.000000,130.000000 
	C140.000000,130.000000 70.500008,130.000000 1.000009,130.000000 
	C1.000006,87.000008 1.000006,44.000015 1.000003,1.000015 
	C90.999992,1.000010 180.999985,1.000010 271.000000,1.000005 
	C271.000000,43.999985 271.000000,86.999969 271.000000,129.999969 
	C250.833328,130.000000 230.666672,130.000000 210.000000,130.000000 
M118.182892,110.435310 
	C118.163109,103.269333 118.084801,96.102936 118.137566,88.937492 
	C118.212563,78.751472 117.224907,80.439835 126.834160,79.902893 
	C134.584869,79.469795 142.551483,79.134651 149.958633,77.082443 
	C166.739243,72.433243 176.206604,57.503048 174.891769,39.606144 
	C173.762100,24.229677 162.728165,12.952098 145.195602,11.098968 
	C132.991394,9.809028 120.594597,10.417336 108.294724,9.912450 
	C104.366135,9.751186 103.019943,11.008150 103.084419,14.946063 
	C103.272644,26.441952 103.149933,37.942894 103.153549,49.441853 
	C103.160316,70.939880 103.149292,92.437973 103.222343,113.935783 
	C103.227638,115.495003 103.724144,118.356636 104.211357,118.404991 
	C108.318626,118.812599 112.561462,119.159851 116.557449,118.416855 
	C117.494652,118.242592 117.648926,113.857620 118.182892,110.435310 
M50.410866,37.932167 
	C36.168068,49.858662 21.925270,61.785160 7.333407,74.003952 
	C26.336918,89.924400 44.880493,105.459526 62.936623,120.586296 
	C66.215630,117.500084 69.213387,114.678589 72.497505,111.587563 
	C57.438438,98.984070 42.496483,86.478584 27.353130,73.804550 
	C42.767307,61.069511 57.602604,48.812733 72.811577,36.247231 
	C69.407547,33.116364 66.293312,30.252039 63.079819,27.296417 
	C59.100697,30.630880 55.023403,34.047615 50.410866,37.932167 
M258.453064,67.072281 
	C242.511459,53.721043 226.569870,40.369804 210.448654,26.868147 
	C207.374268,30.121304 204.473480,33.190773 201.463760,36.375507 
	C216.809769,49.182251 231.688431,61.598984 246.770630,74.185570 
	C231.341446,86.965317 216.513153,99.247353 201.568542,111.625740 
	C204.866211,114.800903 207.837921,117.662216 210.985199,120.692566 
	C229.235626,105.393631 247.812302,89.821205 266.690033,73.996414 
	C263.786652,71.575508 261.378601,69.567612 258.453064,67.072281 
z"
    />
    <path
      fill={letterFill || '#DB3865'} // P
      opacity="1.000000"
      stroke="none"
      d="
M118.173141,110.922577 
	C117.648926,113.857620 117.494652,118.242592 116.557449,118.416855 
	C112.561462,119.159851 108.318626,118.812599 104.211357,118.404991 
	C103.724144,118.356636 103.227638,115.495003 103.222343,113.935783 
	C103.149292,92.437973 103.160316,70.939880 103.153549,49.441853 
	C103.149933,37.942894 103.272644,26.441952 103.084419,14.946063 
	C103.019943,11.008150 104.366135,9.751186 108.294724,9.912450 
	C120.594597,10.417336 132.991394,9.809028 145.195602,11.098968 
	C162.728165,12.952098 173.762100,24.229677 174.891769,39.606144 
	C176.206604,57.503048 166.739243,72.433243 149.958633,77.082443 
	C142.551483,79.134651 134.584869,79.469795 126.834160,79.902893 
	C117.224907,80.439835 118.212563,78.751472 118.137566,88.937492 
	C118.084801,96.102936 118.163109,103.269333 118.173141,110.922577 
M150.259384,26.086306 
	C140.905243,20.619022 130.599899,22.107826 120.520851,22.169401 
	C119.732773,22.174215 118.283028,23.791002 118.272568,24.672039 
	C118.116394,37.821163 118.096092,50.973209 118.254509,64.122032 
	C118.266022,65.077194 119.956512,66.875648 120.774902,66.824287 
	C129.186859,66.296371 137.753250,66.266350 145.928513,64.492981 
	C153.775223,62.790874 158.090744,56.456520 159.026978,48.533569 
	C160.040451,39.956699 159.124939,31.788990 150.259384,26.086306 
z"
    />
    <path
      fill="#F2F3EC" // left arrow
      opacity="1.000000"
      stroke="none"
      d="
M50.678486,37.698257 
	C55.023403,34.047615 59.100697,30.630880 63.079819,27.296417 
	C66.293312,30.252039 69.407547,33.116364 72.811577,36.247231 
	C57.602604,48.812733 42.767307,61.069511 27.353130,73.804550 
	C42.496483,86.478584 57.438438,98.984070 72.497505,111.587563 
	C69.213387,114.678589 66.215630,117.500084 62.936623,120.586296 
	C44.880493,105.459526 26.336918,89.924400 7.333407,74.003952 
	C21.925270,61.785160 36.168068,49.858662 50.678486,37.698257 
z"
    />
    <path
      fill="#F2F3EC" // right arrow
      opacity="1.000000"
      stroke="none"
      d="
M258.711792,67.315994 
	C261.378601,69.567612 263.786652,71.575508 266.690033,73.996414 
	C247.812302,89.821205 229.235626,105.393631 210.985199,120.692566 
	C207.837921,117.662216 204.866211,114.800903 201.568542,111.625740 
	C216.513153,99.247353 231.341446,86.965317 246.770630,74.185570 
	C231.688431,61.598984 216.809769,49.182251 201.463760,36.375507 
	C204.473480,33.190773 207.374268,30.121304 210.448654,26.868147 
	C226.569870,40.369804 242.511459,53.721043 258.711792,67.315994 
z"
    />
    <path
      fill="#2B2321" // space inside P
      opacity="0.01"
      stroke="none"
      d="
M150.578430,26.281263 
	C159.124939,31.788990 160.040451,39.956699 159.026978,48.533569 
	C158.090744,56.456520 153.775223,62.790874 145.928513,64.492981 
	C137.753250,66.266350 129.186859,66.296371 120.774902,66.824287 
	C119.956512,66.875648 118.266022,65.077194 118.254509,64.122032 
	C118.096092,50.973209 118.116394,37.821163 118.272568,24.672039 
	C118.283028,23.791002 119.732773,22.174215 120.520851,22.169401 
	C130.599899,22.107826 140.905243,20.619022 150.578430,26.281263 
z"
    />
  </svg>
);

export const ClosingPtag = ({ width, height, letterFill }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width || '48'}
    height={height || '48'}
    viewBox="0 0 369 153"
    enableBackground="new 0 0 369 153"
  >
    <path
      fill="#252520"
      opacity="0.01"
      stroke="none"
      d="
M8.000000,1.000000 
	C128.606461,1.000000 249.212936,1.000000 369.909698,1.000000 
	C369.909698,51.914215 369.909698,102.828644 369.909698,154.000000 
	C249.645889,154.000000 129.291611,154.000000 8.468666,153.531342 
	C8.000128,132.643127 7.887722,112.222191 8.139036,91.805733 
	C8.171401,89.176468 10.089870,86.570419 11.445383,84.079330 
	C30.369106,99.381920 48.982079,114.558800 66.587265,128.913940 
	C69.992073,126.214561 73.313873,123.580986 76.805725,120.812592 
	C61.289635,107.848625 46.428085,95.431534 31.410160,82.883781 
	C45.250397,71.324562 58.622757,60.156101 72.330872,48.882370 
	C73.923195,47.612942 75.179764,46.448776 76.784782,44.961792 
	C74.301865,43.022385 72.164146,41.352612 69.910309,39.383537 
	C69.074989,38.067310 68.355789,37.050385 67.548340,35.908672 
	C57.230385,44.549507 47.229729,53.077553 37.057213,61.395412 
	C28.875509,68.085426 20.485825,74.521080 11.848554,80.912453 
	C7.844441,79.171341 7.988939,75.946854 7.991169,72.731026 
	C8.007748,48.820694 8.000067,24.910345 8.000000,1.000000 
M272.743652,46.988083 
	C271.969391,44.109261 271.570770,41.059998 270.355408,38.381302 
	C265.262299,27.155895 255.743118,21.411228 244.104935,20.225821 
	C231.900650,18.982750 219.524002,19.523382 207.240494,18.921041 
	C202.472443,18.687233 201.030518,20.119400 201.062775,24.977518 
	C201.269562,56.111801 201.082550,87.248474 201.206879,118.383644 
	C201.251450,129.545975 199.355759,127.643867 211.094315,128.069107 
	C215.130646,128.215332 216.256577,126.649239 216.188080,122.870773 
	C216.013016,113.216896 216.194778,103.557060 216.093781,93.901077 
	C216.056351,90.323837 217.379425,88.778564 221.111023,88.946060 
	C225.761093,89.154785 230.442490,89.125580 235.089951,88.852203 
	C255.993057,87.622627 275.106598,73.667664 272.743652,46.988083 
M168.358948,9.991002 
	C162.426804,8.810690 159.950027,11.632473 157.712219,17.086390 
	C144.224411,49.958405 130.232742,82.623604 116.426331,115.365021 
	C112.189178,125.413269 108.004280,135.483551 103.600250,146.010345 
	C106.748390,146.010345 109.279068,145.695862 111.699783,146.078018 
	C116.265968,146.798843 118.267334,144.799118 119.977959,140.678253 
	C133.346481,108.473763 146.977219,76.378151 160.512619,44.242882 
	C165.261093,32.969227 169.969360,21.678633 174.865616,9.990828 
	C172.564102,9.990828 170.906891,9.990828 168.358948,9.991002 
M303.613617,117.159233 
	C302.314819,118.348221 301.015991,119.537209 299.599487,120.833961 
	C302.816956,123.959267 305.760406,126.818428 308.845245,129.814911 
	C327.268707,114.369843 345.811310,98.824890 364.696777,82.992470 
	C345.665741,67.051292 327.127106,51.522591 309.240082,36.539700 
	C305.724335,39.585453 302.599091,42.292900 299.250153,45.194153 
	C314.643158,58.046051 329.602783,70.536087 344.788605,83.214973 
	C330.853760,94.712318 317.518951,105.714592 303.613617,117.159233 
z"
    />
    <path
      fill="#242424" // background
      opacity="0.01"
      stroke="none"
      d="
M7.502095,1.000000 
	C8.000067,24.910345 8.007748,48.820694 7.991169,72.731026 
	C7.988939,75.946854 7.844441,79.171341 11.725311,81.213348 
	C11.672835,82.432137 11.403734,83.192879 11.134632,83.953621 
	C10.089870,86.570419 8.171401,89.176468 8.139036,91.805733 
	C7.887722,112.222191 8.000128,132.643127 8.000008,153.531342 
	C5.673615,154.000000 3.347229,154.000000 1.015941,154.000000 
	C1.011037,103.000000 1.011037,52.000000 1.016556,1.000000 
	C3.016113,1.000000 5.010152,1.000000 7.502095,1.000000 
z"
    />
    <path
      fill={letterFill || '#DB3865'} // P
      opacity="1.000000"
      stroke="none"
      d="
M272.774506,47.437271 
	C275.106598,73.667664 255.993057,87.622627 235.089951,88.852203 
	C230.442490,89.125580 225.761093,89.154785 221.111023,88.946060 
	C217.379425,88.778564 216.056351,90.323837 216.093781,93.901077 
	C216.194778,103.557060 216.013016,113.216896 216.188080,122.870773 
	C216.256577,126.649239 215.130646,128.215332 211.094315,128.069107 
	C199.355759,127.643867 201.251450,129.545975 201.206879,118.383644 
	C201.082550,87.248474 201.269562,56.111801 201.062775,24.977518 
	C201.030518,20.119400 202.472443,18.687233 207.240494,18.921041 
	C219.524002,19.523382 231.900650,18.982750 244.104935,20.225821 
	C255.743118,21.411228 265.262299,27.155895 270.355408,38.381302 
	C271.570770,41.059998 271.969391,44.109261 272.774506,47.437271 
M250.083359,36.299942 
	C240.304260,29.374891 229.102448,31.063200 218.203033,31.249695 
	C217.487778,31.261934 216.227158,33.664371 216.211273,34.967091 
	C216.059097,47.454342 216.025238,59.946068 216.271606,72.430321 
	C216.295486,73.640190 218.363998,75.741653 219.600098,75.831970 
	C224.565842,76.194786 229.621109,76.336311 234.562714,75.807167 
	C243.634430,74.835777 252.361191,72.383636 255.630524,62.553844 
	C258.713654,53.283852 258.741089,44.120419 250.083359,36.299942 
z"
    />
    <path
      fill="#F2F3EC"
      opacity="1.000000"
      stroke="none"
      d="
M168.804321,9.990915 
	C170.906891,9.990828 172.564102,9.990828 174.865616,9.990828 
	C169.969360,21.678633 165.261093,32.969227 160.512619,44.242882 
	C146.977219,76.378151 133.346481,108.473763 119.977959,140.678253 
	C118.267334,144.799118 116.265968,146.798843 111.699783,146.078018 
	C109.279068,145.695862 106.748390,146.010345 103.600250,146.010345 
	C108.004280,135.483551 112.189178,125.413269 116.426331,115.365021 
	C130.232742,82.623604 144.224411,49.958405 157.712219,17.086390 
	C159.950027,11.632473 162.426804,8.810690 168.804321,9.990915 
z"
    />
    <path
      fill="#F2F3EC"
      opacity="1.000000"
      stroke="none"
      d="
M303.898865,116.938049 
	C317.518951,105.714592 330.853760,94.712318 344.788605,83.214973 
	C329.602783,70.536087 314.643158,58.046051 299.250153,45.194153 
	C302.599091,42.292900 305.724335,39.585453 309.240082,36.539700 
	C327.127106,51.522591 345.665741,67.051292 364.696777,82.992470 
	C345.811310,98.824890 327.268707,114.369843 308.845245,129.814911 
	C305.760406,126.818428 302.816956,123.959267 299.599487,120.833961 
	C301.015991,119.537209 302.314819,118.348221 303.898865,116.938049 
z"
    />
    <path
      fill="#F2F3EC"
      opacity="1.000000"
      stroke="none"
      d="
M11.445385,84.079330 
	C11.403734,83.192879 11.672835,82.432137 12.065180,81.370499 
	C20.485825,74.521080 28.875509,68.085426 37.057213,61.395412 
	C47.229729,53.077553 57.230385,44.549507 67.548340,35.908672 
	C68.355789,37.050385 69.074989,38.067310 69.907867,39.747520 
	C70.679405,43.269753 71.337265,46.128696 71.995117,48.987640 
	C58.622757,60.156101 45.250397,71.324562 31.410160,82.883781 
	C46.428085,95.431534 61.289635,107.848625 76.805725,120.812592 
	C73.313873,123.580986 69.992073,126.214561 66.587265,128.913940 
	C48.982079,114.558800 30.369106,99.381920 11.445385,84.079330 
z"
    />
    <path
      fill="#EFEDE1"
      opacity="1.000000"
      stroke="none"
      d="
M72.330872,48.882370 
	C71.337265,46.128696 70.679405,43.269753 70.023987,40.046822 
	C72.164146,41.352612 74.301865,43.022385 76.784782,44.961792 
	C75.179764,46.448776 73.923195,47.612942 72.330872,48.882370 
z"
    />
    <path
      fill="#2B2321"
      opacity="0.01"
      stroke="none"
      d="
M250.359940,36.542675 
	C258.741089,44.120419 258.713654,53.283852 255.630524,62.553844 
	C252.361191,72.383636 243.634430,74.835777 234.562714,75.807167 
	C229.621109,76.336311 224.565842,76.194786 219.600098,75.831970 
	C218.363998,75.741653 216.295486,73.640190 216.271606,72.430321 
	C216.025238,59.946068 216.059097,47.454342 216.211273,34.967091 
	C216.227158,33.664371 217.487778,31.261934 218.203033,31.249695 
	C229.102448,31.063200 240.304260,29.374891 250.359940,36.542675 
z"
    />
  </svg>
);

export const CalendlyIcon = ({
  width,
  letterFill,
  outlineFillOne,
  innerLogoFillTwo,
  logoFillThree,
  logoFillBG,
  innerColorFill,
}) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width || '120px'}
    viewBox="0 0 1511 379"
    enableBackground="new 0 0 1511 379"
  >
    <path
      fill="#242424"
      opacity="0.01"
      stroke="none"
      d="
M997.000000,380.000000 
	C664.710510,380.000000 332.921021,380.000000 1.065774,380.000000 
	C1.065774,253.727234 1.065774,127.454437 1.065774,1.090816 
	C504.666656,1.090816 1008.333313,1.090816 1511.965698,1.090816 
	C1511.965698,127.412430 1511.965698,253.706223 1511.965698,380.000000 
	C1340.454224,380.000000 1168.977173,380.000000 997.000000,380.000000 
M311.670380,162.152756 
	C313.430054,161.453079 315.203217,160.785278 316.947144,160.048279 
	C325.331146,156.505020 333.971375,153.445679 342.001312,149.226196 
	C348.242126,145.946823 349.992401,139.519669 348.075439,132.823410 
	C327.822052,62.074657 254.502243,15.157061 182.014771,26.560640 
	C98.360489,39.720959 43.302731,112.926750 53.864670,196.951324 
	C62.691414,267.171661 124.249214,323.830475 194.984283,326.840149 
	C265.582031,329.843994 326.549591,287.258331 347.849915,220.109543 
	C350.016663,213.279037 348.431244,207.671585 342.942200,203.122894 
	C333.861328,195.597702 323.199493,191.572495 311.809753,188.186630 
	C311.695282,179.774765 311.580811,171.362885 311.670380,162.152756 
M1109.066162,252.421600 
	C1116.024902,262.254089 1124.808838,270.045258 1135.477051,275.616974 
	C1163.541992,290.274475 1198.977295,287.352631 1220.097778,259.574738 
	C1220.482666,259.068542 1220.544556,258.316803 1220.757202,257.679626 
	C1221.320557,257.958679 1221.883911,258.237762 1222.447266,258.516846 
	C1222.447266,264.571136 1222.566040,270.628754 1222.397461,276.678406 
	C1222.312378,279.737793 1223.438721,280.796448 1226.463745,280.691254 
	C1231.622681,280.511810 1236.817261,280.330902 1241.950073,280.738953 
	C1246.696899,281.116333 1247.769775,279.314423 1247.760864,274.817505 
	C1247.629639,208.837402 1247.672729,142.856964 1247.658936,76.876602 
	C1247.658569,75.094856 1247.484985,73.313141 1247.382568,71.346924 
	C1238.985962,71.346924 1231.059326,71.346924 1222.418457,71.346924 
	C1222.418457,100.763000 1222.418457,129.948700 1222.418457,160.612366 
	C1220.663940,158.599884 1219.933838,157.794724 1219.238770,156.960419 
	C1202.794189,137.222580 1181.689575,129.825043 1156.741699,134.680679 
	C1102.589722,145.220337 1077.923462,205.696259 1109.066162,252.421600 
M1412.874878,193.499954 
	C1412.615479,204.816742 1413.257446,216.241745 1411.914062,227.428345 
	C1408.885132,252.652084 1386.736450,266.569519 1362.217407,259.479126 
	C1345.085449,254.524933 1334.193848,239.260239 1334.106079,219.633041 
	C1333.992188,194.138336 1334.077515,168.642761 1334.077148,143.147552 
	C1334.077026,141.213364 1334.077148,139.279175 1334.077148,137.278290 
	C1325.320190,137.278290 1317.258057,137.278290 1309.324219,137.278290 
	C1309.088257,137.945053 1308.885010,138.250656 1308.885620,138.555893 
	C1308.938965,167.212067 1307.381470,195.985260 1309.433716,224.498566 
	C1313.062256,274.911163 1355.401855,289.396240 1389.015625,282.472870 
	C1399.515869,280.310211 1407.828735,274.666840 1413.956787,265.235748 
	C1413.853027,279.767120 1413.583740,294.060059 1411.865479,308.176636 
	C1410.659424,318.085510 1405.333374,326.473267 1396.260986,331.455109 
	C1375.205200,343.017273 1345.276489,335.326294 1337.575806,307.766968 
	C1337.184814,306.367798 1336.744873,304.982300 1336.206543,303.186127 
	C1328.624878,305.833405 1321.334717,308.378876 1314.136719,310.892181 
	C1318.101685,331.730713 1334.944702,350.659363 1356.061401,356.485809 
	C1379.190796,362.867615 1401.283691,360.427673 1419.534302,343.290955 
	C1433.816528,329.880432 1438.101196,312.114990 1438.142090,293.196533 
	C1438.250488,243.039551 1438.181641,192.882172 1438.169067,142.724945 
	C1438.168579,140.947433 1438.018677,139.169937 1437.932739,137.267319 
	C1429.455933,137.267319 1421.400879,137.267319 1412.875000,137.267319 
	C1412.875000,155.910721 1412.875000,174.205338 1412.874878,193.499954 
M583.793945,249.671967 
	C581.826538,246.623276 579.859131,243.574585 577.719910,240.259613 
	C560.166321,253.965393 540.514404,259.393829 518.936890,257.065521 
	C496.981079,254.696396 479.116241,244.443085 465.651764,226.965775 
	C441.666290,195.831802 444.890381,151.481888 473.049225,123.998444 
	C486.675018,110.699509 503.082275,103.160675 522.109558,101.982483 
	C549.670654,100.275864 571.954834,110.999619 589.628784,132.092484 
	C596.833008,126.707558 603.692627,121.580231 610.531799,116.468193 
	C589.313293,86.920692 546.102478,67.209984 501.390350,78.862549 
	C456.809845,90.480804 426.186188,128.768311 423.421478,176.457840 
	C420.948212,219.120087 448.376953,260.796692 489.415283,277.240631 
	C527.388916,292.456543 570.168701,281.876892 591.532043,262.124207 
	C589.084167,258.204742 586.617126,254.254593 583.793945,249.671967 
M592.853455,194.459290 
	C585.583740,230.670822 606.342529,267.697052 641.336975,279.775024 
	C667.800476,288.908600 691.913025,285.054077 712.172058,264.492554 
	C714.210815,262.423401 715.991028,260.099426 718.849609,256.781189 
	C718.849609,265.355286 718.849609,272.550232 718.849609,279.890717 
	C727.421204,279.890717 735.333374,279.890717 743.541626,279.890717 
	C743.541626,232.210022 743.541626,184.830948 743.541626,137.328445 
	C735.173035,137.328445 727.134766,137.328445 718.565613,137.328445 
	C718.565613,144.961548 718.565613,152.188049 718.565613,159.480972 
	C717.873413,159.365829 717.658081,159.396378 717.579407,159.306839 
	C716.598633,158.190308 715.641296,157.053329 714.671204,155.927338 
	C700.803162,139.830933 683.216187,131.898117 662.049255,133.534042 
	C626.916992,136.249313 600.894165,159.215179 592.853455,194.459290 
M862.224548,133.577148 
	C860.421570,133.898590 858.594116,134.120209 856.819214,134.555969 
	C800.011230,148.502625 786.703491,210.465546 811.795349,250.427536 
	C826.233093,273.421356 848.515869,282.873566 874.865662,283.831818 
	C899.370911,284.722992 919.824890,276.049225 935.686584,257.124237 
	C937.129150,255.403168 938.312012,253.464371 939.921570,251.195145 
	C932.364380,247.265839 925.353760,243.620728 918.363586,239.986267 
	C901.848511,260.898926 880.706970,264.061188 857.311340,256.750641 
	C839.786316,251.274536 829.778198,238.464935 825.639587,219.944412 
	C828.213989,219.944412 830.165344,219.944427 832.116760,219.944412 
	C868.283020,219.944107 904.449280,219.931824 940.615540,219.965607 
	C943.584534,219.968384 945.842834,220.175964 946.230408,215.875137 
	C950.148254,172.397705 919.278198,126.613220 862.224548,133.577148 
M991.550842,147.045410 
	C989.032715,149.808228 986.514526,152.571045 983.166504,156.244415 
	C983.166504,149.237213 983.166504,143.355881 983.166504,137.306915 
	C974.549194,137.306915 966.519592,137.306915 958.478699,137.306915 
	C958.478699,185.079559 958.478699,232.457367 958.478699,279.854523 
	C966.808167,279.854523 974.729553,279.854523 983.166199,279.854523 
	C983.166199,268.570129 983.083923,257.613586 983.185059,246.658707 
	C983.345093,229.341705 982.689331,211.950165 984.077515,194.727066 
	C986.197144,168.428802 1006.536316,153.544998 1032.603394,157.805008 
	C1046.704590,160.109482 1056.146729,168.969849 1058.936401,182.902756 
	C1059.714844,186.790573 1060.026245,190.830902 1060.040405,194.803085 
	C1060.134277,221.128082 1060.088745,247.453568 1060.088623,273.778900 
	C1060.088623,275.706482 1060.088623,277.634094 1060.088623,279.667114 
	C1068.776245,279.667114 1076.690918,279.667114 1084.821655,279.667114 
	C1084.959717,278.428497 1085.159912,277.468506 1085.160278,276.508453 
	C1085.171753,247.184128 1085.292603,217.858948 1085.095093,188.535919 
	C1085.016357,176.840958 1082.030151,165.776291 1075.520386,155.892548 
	C1058.124512,129.480606 1017.343567,124.944557 991.550842,147.045410 
M1292.684814,103.500168 
	C1292.684814,92.746155 1292.684814,81.992149 1292.684814,71.194298 
	C1283.875854,71.194298 1275.947632,71.194298 1267.769043,71.194298 
	C1267.769043,140.892029 1267.769043,210.285263 1267.769043,279.827087 
	C1276.174805,279.827087 1284.241821,279.827087 1292.684814,279.827087 
	C1292.684814,221.130341 1292.684814,162.815262 1292.684814,103.500168 
M788.158386,184.500092 
	C788.158386,146.763779 788.158386,109.027466 788.158386,71.215302 
	C779.467407,71.215302 771.554260,71.215302 763.380859,71.215302 
	C763.380859,140.884232 763.380859,210.246521 763.380859,279.784210 
	C771.719055,279.784210 779.750000,279.784210 788.158386,279.784210 
	C788.158386,248.087234 788.158386,216.793671 788.158386,184.500092 
z"
    />
    <path
      fill={outlineFillOne || '#2054F5'} // outline of C
      opacity="1.000000"
      stroke="none"
      d="
M311.846161,189.078568 
	C323.199493,191.572495 333.861328,195.597702 342.942200,203.122894 
	C348.431244,207.671585 350.016663,213.279037 347.849915,220.109543 
	C326.549591,287.258331 265.582031,329.843994 194.984283,326.840149 
	C124.249214,323.830475 62.691414,267.171661 53.864670,196.951324 
	C43.302731,112.926750 98.360489,39.720959 182.014771,26.560640 
	C254.502243,15.157061 327.822052,62.074657 348.075439,132.823410 
	C349.992401,139.519669 348.242126,145.946823 342.001312,149.226196 
	C333.971375,153.445679 325.331146,156.505020 316.947144,160.048279 
	C315.203217,160.785278 313.430054,161.453079 311.348938,162.507965 
	C311.027527,162.863159 310.590271,162.768295 310.720642,162.387909 
	C309.231171,156.743118 307.611328,151.478699 305.994141,145.833145 
	C306.006866,144.944305 306.016937,144.436584 306.337097,144.170349 
	C314.498260,145.946075 320.609589,141.455383 327.218414,138.570587 
	C331.376099,136.755722 332.066895,134.472046 330.483917,130.068420 
	C308.554443,69.063011 248.104675,32.876369 182.917496,41.953209 
	C110.125114,52.089020 57.519825,124.435196 70.358353,196.751785 
	C83.638542,271.556183 151.219391,320.570862 226.070251,307.688232 
	C277.673126,298.806854 312.435730,267.927917 330.946472,218.859024 
	C332.131836,215.716797 331.604462,213.749191 328.582062,212.549911 
	C321.967102,209.925125 315.318329,207.385513 308.544922,204.559479 
	C308.295197,204.149429 308.183929,203.991013 308.192505,203.446533 
	C309.427399,198.468353 310.542450,193.876236 311.703247,189.231415 
	C311.748962,189.178711 311.846161,189.078568 311.846161,189.078568 
z"
    />
    <path
      fill={letterFill || '#2054F5'} // d
      opacity="1.000000"
      stroke="none"
      d="
M1108.866333,252.123596 
	C1077.923462,205.696259 1102.589722,145.220337 1156.741699,134.680679 
	C1181.689575,129.825043 1202.794189,137.222580 1219.238770,156.960419 
	C1219.933838,157.794724 1220.663940,158.599884 1222.418457,160.612366 
	C1222.418457,129.948700 1222.418457,100.763000 1222.418457,71.346924 
	C1231.059326,71.346924 1238.985962,71.346924 1247.382568,71.346924 
	C1247.484985,73.313141 1247.658569,75.094856 1247.658936,76.876602 
	C1247.672729,142.856964 1247.629639,208.837402 1247.760864,274.817505 
	C1247.769775,279.314423 1246.696899,281.116333 1241.950073,280.738953 
	C1236.817261,280.330902 1231.622681,280.511810 1226.463745,280.691254 
	C1223.438721,280.796448 1222.312378,279.737793 1222.397461,276.678406 
	C1222.566040,270.628754 1222.447266,264.571136 1222.447266,258.516846 
	C1221.883911,258.237762 1221.320557,257.958679 1220.757202,257.679626 
	C1220.544556,258.316803 1220.482666,259.068542 1220.097778,259.574738 
	C1198.977295,287.352631 1163.541992,290.274475 1135.477051,275.616974 
	C1124.808838,270.045258 1116.024902,262.254089 1108.866333,252.123596 
M1139.403809,248.136246 
	C1140.191650,248.750641 1140.960205,249.391785 1141.770142,249.975510 
	C1159.622559,262.841248 1183.605469,263.124634 1201.217773,250.684906 
	C1218.712524,238.328171 1226.445312,216.329010 1220.651367,195.396820 
	C1214.870850,174.513031 1196.138672,159.478485 1174.272949,158.173157 
	C1153.434204,156.929123 1133.248169,169.597672 1124.959106,189.121902 
	C1116.262695,209.605713 1121.550903,231.890396 1139.403809,248.136246 
z"
    />
    <path
      fill={letterFill || '#2054F5'} // y
      opacity="1.000000"
      stroke="none"
      d="
M1412.875000,192.999939 
	C1412.875000,174.205338 1412.875000,155.910721 1412.875000,137.267319 
	C1421.400879,137.267319 1429.455933,137.267319 1437.932739,137.267319 
	C1438.018677,139.169937 1438.168579,140.947433 1438.169067,142.724945 
	C1438.181641,192.882172 1438.250488,243.039551 1438.142090,293.196533 
	C1438.101196,312.114990 1433.816528,329.880432 1419.534302,343.290955 
	C1401.283691,360.427673 1379.190796,362.867615 1356.061401,356.485809 
	C1334.944702,350.659363 1318.101685,331.730713 1314.136719,310.892181 
	C1321.334717,308.378876 1328.624878,305.833405 1336.206543,303.186127 
	C1336.744873,304.982300 1337.184814,306.367798 1337.575806,307.766968 
	C1345.276489,335.326294 1375.205200,343.017273 1396.260986,331.455109 
	C1405.333374,326.473267 1410.659424,318.085510 1411.865479,308.176636 
	C1413.583740,294.060059 1413.853027,279.767120 1413.956787,265.235748 
	C1407.828735,274.666840 1399.515869,280.310211 1389.015625,282.472870 
	C1355.401855,289.396240 1313.062256,274.911163 1309.433716,224.498566 
	C1307.381470,195.985260 1308.938965,167.212067 1308.885620,138.555893 
	C1308.885010,138.250656 1309.088257,137.945053 1309.324219,137.278290 
	C1317.258057,137.278290 1325.320190,137.278290 1334.077148,137.278290 
	C1334.077148,139.279175 1334.077026,141.213364 1334.077148,143.147552 
	C1334.077515,168.642761 1333.992188,194.138336 1334.106079,219.633041 
	C1334.193848,239.260239 1345.085449,254.524933 1362.217407,259.479126 
	C1386.736450,266.569519 1408.885132,252.652084 1411.914062,227.428345 
	C1413.257446,216.241745 1412.615479,204.816742 1412.875000,192.999939 
z"
    />
    <path
      fill={letterFill || '#2054F5'} // C
      opacity="1.000000"
      stroke="none"
      d="
M583.971985,249.988205 
	C586.617126,254.254593 589.084167,258.204742 591.532043,262.124207 
	C570.168701,281.876892 527.388916,292.456543 489.415283,277.240631 
	C448.376953,260.796692 420.948212,219.120087 423.421478,176.457840 
	C426.186188,128.768311 456.809845,90.480804 501.390350,78.862549 
	C546.102478,67.209984 589.313293,86.920692 610.531799,116.468193 
	C603.692627,121.580231 596.833008,126.707558 589.628784,132.092484 
	C571.954834,110.999619 549.670654,100.275864 522.109558,101.982483 
	C503.082275,103.160675 486.675018,110.699509 473.049225,123.998444 
	C444.890381,151.481888 441.666290,195.831802 465.651764,226.965775 
	C479.116241,244.443085 496.981079,254.696396 518.936890,257.065521 
	C540.514404,259.393829 560.166321,253.965393 577.719910,240.259613 
	C579.859131,243.574585 581.826538,246.623276 583.971985,249.988205 
z"
    />
    <path
      fill={letterFill || '#2054F5'} // a
      opacity="1.000000"
      stroke="none"
      d="
M592.914917,194.034149 
	C600.894165,159.215179 626.916992,136.249313 662.049255,133.534042 
	C683.216187,131.898117 700.803162,139.830933 714.671204,155.927338 
	C715.641296,157.053329 716.598633,158.190308 717.579407,159.306839 
	C717.658081,159.396378 717.873413,159.365829 718.565613,159.480972 
	C718.565613,152.188049 718.565613,144.961548 718.565613,137.328445 
	C727.134766,137.328445 735.173035,137.328445 743.541626,137.328445 
	C743.541626,184.830948 743.541626,232.210022 743.541626,279.890717 
	C735.333374,279.890717 727.421204,279.890717 718.849609,279.890717 
	C718.849609,272.550232 718.849609,265.355286 718.849609,256.781189 
	C715.991028,260.099426 714.210815,262.423401 712.172058,264.492554 
	C691.913025,285.054077 667.800476,288.908600 641.336975,279.775024 
	C606.342529,267.697052 585.583740,230.670822 592.914917,194.034149 
M628.502686,240.962341 
	C629.970886,242.552567 631.360291,244.225006 632.919495,245.720367 
	C649.369446,261.496613 675.004883,264.379456 694.413757,252.670441 
	C714.190247,240.739685 723.235474,217.102158 716.646240,194.571121 
	C710.316833,172.928391 689.736572,157.484924 667.146545,158.212082 
	C646.784424,158.867554 631.312439,168.460663 622.393799,186.781754 
	C613.284546,205.494186 615.643677,223.638458 628.502686,240.962341 
z"
    />
    <path
      fill={letterFill || '#2054F5'} // e
      opacity="1.000000"
      stroke="none"
      d="
M862.665344,133.488098 
	C919.278198,126.613220 950.148254,172.397705 946.230408,215.875137 
	C945.842834,220.175964 943.584534,219.968384 940.615540,219.965607 
	C904.449280,219.931824 868.283020,219.944107 832.116760,219.944412 
	C830.165344,219.944427 828.213989,219.944412 825.639587,219.944412 
	C829.778198,238.464935 839.786316,251.274536 857.311340,256.750641 
	C880.706970,264.061188 901.848511,260.898926 918.363586,239.986267 
	C925.353760,243.620728 932.364380,247.265839 939.921570,251.195145 
	C938.312012,253.464371 937.129150,255.403168 935.686584,257.124237 
	C919.824890,276.049225 899.370911,284.722992 874.865662,283.831818 
	C848.515869,282.873566 826.233093,273.421356 811.795349,250.427536 
	C786.703491,210.465546 800.011230,148.502625 856.819214,134.555969 
	C858.594116,134.120209 860.421570,133.898590 862.665344,133.488098 
M885.500000,197.892441 
	C897.223450,197.892441 908.946960,197.892441 920.675110,197.892441 
	C920.060730,174.129211 898.147461,155.829987 872.028259,156.488541 
	C848.162231,157.090286 825.722595,177.115417 826.249512,197.892441 
	C845.654236,197.892441 865.077148,197.892441 885.500000,197.892441 
z"
    />
    <path
      fill={innerLogoFillTwo || '#2054F5'} // inner C
      opacity="1.000000"
      stroke="none"
      d="
M310.590271,162.768295 
	C310.590271,162.768295 311.027527,162.863159 311.246918,162.907089 
	C311.580811,171.362885 311.695282,179.774765 311.827942,188.632599 
	C311.846161,189.078568 311.748962,189.178711 311.297852,189.174988 
	C285.702087,185.358185 263.166107,190.270340 244.586288,208.765198 
	C241.885361,211.453766 239.015396,214.267746 235.683578,215.960953 
	C230.125214,218.785629 224.300644,221.912018 218.277817,222.795319 
	C210.131851,223.989975 201.635361,223.834015 193.390732,223.106934 
	C174.368256,221.429382 160.173126,205.627472 159.824081,186.481766 
	C159.693573,179.323242 159.684143,172.157883 159.828445,164.999863 
	C160.223190,145.419510 175.569855,129.775314 195.063553,128.155609 
	C215.125107,126.488747 233.222244,129.821198 247.305405,145.699692 
	C249.050354,147.667053 251.339813,149.171463 253.457260,150.785019 
	C262.700623,157.828613 273.161621,162.116287 284.701294,162.880508 
	C293.290802,163.449371 301.957794,162.848312 310.590271,162.768295 
z"
    />
    <path
      fill={letterFill || '#2054F5'} // n
      opacity="1.000000"
      stroke="none"
      d="
M991.814941,146.805756 
	C1017.343567,124.944557 1058.124512,129.480606 1075.520386,155.892548 
	C1082.030151,165.776291 1085.016357,176.840958 1085.095093,188.535919 
	C1085.292603,217.858948 1085.171753,247.184128 1085.160278,276.508453 
	C1085.159912,277.468506 1084.959717,278.428497 1084.821655,279.667114 
	C1076.690918,279.667114 1068.776245,279.667114 1060.088623,279.667114 
	C1060.088623,277.634094 1060.088623,275.706482 1060.088623,273.778900 
	C1060.088745,247.453568 1060.134277,221.128082 1060.040405,194.803085 
	C1060.026245,190.830902 1059.714844,186.790573 1058.936401,182.902756 
	C1056.146729,168.969849 1046.704590,160.109482 1032.603394,157.805008 
	C1006.536316,153.544998 986.197144,168.428802 984.077515,194.727066 
	C982.689331,211.950165 983.345093,229.341705 983.185059,246.658707 
	C983.083923,257.613586 983.166199,268.570129 983.166199,279.854523 
	C974.729553,279.854523 966.808167,279.854523 958.478699,279.854523 
	C958.478699,232.457367 958.478699,185.079559 958.478699,137.306915 
	C966.519592,137.306915 974.549194,137.306915 983.166504,137.306915 
	C983.166504,143.355881 983.166504,149.237213 983.166504,156.244415 
	C986.514526,152.571045 989.032715,149.808228 991.814941,146.805756 
z"
    />
    <path
      fill={letterFill || '#2054F5'} // l
      opacity="1.000000"
      stroke="none"
      d="
M1292.684814,104.000168 
	C1292.684814,162.815262 1292.684814,221.130341 1292.684814,279.827087 
	C1284.241821,279.827087 1276.174805,279.827087 1267.769043,279.827087 
	C1267.769043,210.285263 1267.769043,140.892029 1267.769043,71.194298 
	C1275.947632,71.194298 1283.875854,71.194298 1292.684814,71.194298 
	C1292.684814,81.992149 1292.684814,92.746155 1292.684814,104.000168 
z"
    />
    <path
      fill={letterFill || '#2054F5'} // l
      opacity="1.000000"
      stroke="none"
      d="
M788.158386,185.000092 
	C788.158386,216.793671 788.158386,248.087234 788.158386,279.784210 
	C779.750000,279.784210 771.719055,279.784210 763.380859,279.784210 
	C763.380859,210.246521 763.380859,140.884232 763.380859,71.215302 
	C771.554260,71.215302 779.467407,71.215302 788.158386,71.215302 
	C788.158386,109.027466 788.158386,146.763779 788.158386,185.000092 
z"
    />
    <path
      fill={logoFillThree || '#2054F5'} // C background
      opacity="1.000000"
      stroke="none"
      d="
M306.027008,143.928879 
	C306.016937,144.436584 306.006866,144.944305 305.608765,145.981964 
	C285.861664,149.234741 269.002258,144.579544 255.139313,130.170013 
	C244.304153,118.907677 230.897736,112.722244 215.238846,111.932518 
	C208.430969,111.589188 201.575623,111.582809 194.768478,111.936279 
	C167.869659,113.333023 146.176437,133.872070 143.893143,160.709579 
	C143.022171,170.946976 142.853989,181.427948 143.995377,191.615295 
	C146.532074,214.256302 158.993240,229.938721 180.808533,236.708862 
	C189.186249,239.308807 198.492523,239.323776 207.409866,239.694336 
	C226.762375,240.498550 243.245895,233.833420 256.646454,219.631546 
	C262.939331,212.962418 270.648529,208.433105 280.015869,206.000687 
	C287.218170,205.674927 293.945404,205.195160 300.675049,205.158203 
	C302.615479,205.147537 304.562897,206.411346 306.363281,207.430267 
	C298.987488,220.508072 292.362305,233.641525 284.384857,245.894562 
	C271.616577,265.506165 253.158875,277.446228 229.856857,279.960815 
	C215.185226,281.544098 200.224030,281.425385 185.444550,280.815247 
	C158.306000,279.694885 136.947205,267.394775 122.179993,244.559891 
	C115.317062,233.947540 109.004631,222.906006 103.331055,211.612717 
	C90.953499,186.975082 91.412315,162.134583 104.259209,137.764404 
	C109.613647,127.607178 115.475815,117.689308 121.593140,107.968445 
	C134.160767,87.997566 152.110092,75.147369 175.536591,72.105026 
	C190.142105,70.208244 205.114655,70.854248 219.922180,70.863045 
	C242.252502,70.876320 261.342529,79.249115 276.389404,95.574036 
	C289.365784,109.652603 297.276306,127.111565 306.027008,143.928879 
z"
    />
    <path
      fill={logoFillBG || 'transparent'} // C background
      opacity="1"
      stroke="none"
      d="
M306.337097,144.170349 
	C297.276306,127.111565 289.365784,109.652603 276.389404,95.574036 
	C261.342529,79.249115 242.252502,70.876320 219.922180,70.863045 
	C205.114655,70.854248 190.142105,70.208244 175.536591,72.105026 
	C152.110092,75.147369 134.160767,87.997566 121.593140,107.968445 
	C115.475815,117.689308 109.613647,127.607178 104.259209,137.764404 
	C91.412315,162.134583 90.953499,186.975082 103.331055,211.612717 
	C109.004631,222.906006 115.317062,233.947540 122.179993,244.559891 
	C136.947205,267.394775 158.306000,279.694885 185.444550,280.815247 
	C200.224030,281.425385 215.185226,281.544098 229.856857,279.960815 
	C253.158875,277.446228 271.616577,265.506165 284.384857,245.894562 
	C292.362305,233.641525 298.987488,220.508072 306.548767,207.228897 
	C307.479797,206.062439 308.081573,205.436768 308.683380,204.811096 
	C315.318329,207.385513 321.967102,209.925125 328.582062,212.549911 
	C331.604462,213.749191 332.131836,215.716797 330.946472,218.859024 
	C312.435730,267.927917 277.673126,298.806854 226.070251,307.688232 
	C151.219391,320.570862 83.638542,271.556183 70.358353,196.751785 
	C57.519825,124.435196 110.125114,52.089020 182.917496,41.953209 
	C248.104675,32.876369 308.554443,69.063011 330.483917,130.068420 
	C332.066895,134.472046 331.376099,136.755722 327.218414,138.570587 
	C320.609589,141.455383 314.498260,145.946075 306.337097,144.170349 
z"
    />
    <path
      fill={innerColorFill || '#53DDEC'} // C second color
      opacity="1.000000"
      stroke="none"
      d="
M279.541748,206.015167 
	C270.648529,208.433105 262.939331,212.962418 256.646454,219.631546 
	C243.245895,233.833420 226.762375,240.498550 207.409866,239.694336 
	C198.492523,239.323776 189.186249,239.308807 180.808533,236.708862 
	C158.993240,229.938721 146.532074,214.256302 143.995377,191.615295 
	C142.853989,181.427948 143.022171,170.946976 143.893143,160.709579 
	C146.176437,133.872070 167.869659,113.333023 194.768478,111.936279 
	C201.575623,111.582809 208.430969,111.589188 215.238846,111.932518 
	C230.897736,112.722244 244.304153,118.907677 255.139313,130.170013 
	C269.002258,144.579544 285.861664,149.234741 305.606079,146.363098 
	C307.611328,151.478699 309.231171,156.743118 310.720642,162.387909 
	C301.957794,162.848312 293.290802,163.449371 284.701294,162.880508 
	C273.161621,162.116287 262.700623,157.828613 253.457260,150.785019 
	C251.339813,149.171463 249.050354,147.667053 247.305405,145.699692 
	C233.222244,129.821198 215.125107,126.488747 195.063553,128.155609 
	C175.569855,129.775314 160.223190,145.419510 159.828445,164.999863 
	C159.684143,172.157883 159.693573,179.323242 159.824081,186.481766 
	C160.173126,205.627472 174.368256,221.429382 193.390732,223.106934 
	C201.635361,223.834015 210.131851,223.989975 218.277817,222.795319 
	C224.300644,221.912018 230.125214,218.785629 235.683578,215.960953 
	C239.015396,214.267746 241.885361,211.453766 244.586288,208.765198 
	C263.166107,190.270340 285.702087,185.358185 311.252136,189.227692 
	C310.542450,193.876236 309.427399,198.468353 307.827026,203.578262 
	C298.075043,204.735748 288.808380,205.375458 279.541748,206.015167 
z"
    />
    <path
      fill="#2D66B6"
      opacity="1.000000"
      stroke="none"
      d="
M280.015869,206.000702 
	C288.808380,205.375458 298.075043,204.735748 307.707153,203.964325 
	C308.183929,203.991013 308.295197,204.149429 308.544922,204.559464 
	C308.081573,205.436768 307.479797,206.062439 306.692566,206.889496 
	C304.562897,206.411346 302.615479,205.147537 300.675049,205.158203 
	C293.945404,205.195160 287.218170,205.674927 280.015869,206.000702 
z"
    />
    <path
      fill="#242425"
      opacity="0.01"
      stroke="none"
      d="
M1139.129639,247.909088 
	C1121.550903,231.890396 1116.262695,209.605713 1124.959106,189.121902 
	C1133.248169,169.597672 1153.434204,156.929123 1174.272949,158.173157 
	C1196.138672,159.478485 1214.870850,174.513031 1220.651367,195.396820 
	C1226.445312,216.329010 1218.712524,238.328171 1201.217773,250.684906 
	C1183.605469,263.124634 1159.622559,262.841248 1141.770142,249.975510 
	C1140.960205,249.391785 1140.191650,248.750641 1139.129639,247.909088 
z"
    />
    <path
      fill="#242425"
      opacity="0.01"
      stroke="none"
      d="
M628.282715,240.680923 
	C615.643677,223.638458 613.284546,205.494186 622.393799,186.781754 
	C631.312439,168.460663 646.784424,158.867554 667.146545,158.212082 
	C689.736572,157.484924 710.316833,172.928391 716.646240,194.571121 
	C723.235474,217.102158 714.190247,240.739685 694.413757,252.670441 
	C675.004883,264.379456 649.369446,261.496613 632.919495,245.720367 
	C631.360291,244.225006 629.970886,242.552567 628.282715,240.680923 
z"
    />
    <path
      fill="#242527"
      opacity="0.01"
      stroke="none"
      d="
M885.000000,197.892441 
	C865.077148,197.892441 845.654236,197.892441 826.249512,197.892441 
	C825.722595,177.115417 848.162231,157.090286 872.028259,156.488541 
	C898.147461,155.829987 920.060730,174.129211 920.675110,197.892441 
	C908.946960,197.892441 897.223450,197.892441 885.000000,197.892441 
z"
    />
  </svg>
);

export const SmallCalendlyIcon = ({ width, height, fill1, fill2 }) => (
  <svg
    version="1.1"
    id="katman_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width || '48px'}
    height={height || '48px'}
    viewBox="0 0 841.89 595.28"
  >
    <style type="text/css">
      .st0{fill1 || '#3664AE'}
      .st1{fill2 || '#5FC2D6'}
    </style>
    <path
      class="st0"
      fill={fill1 || '#3664AE'}
      d="M505.27,365.28c-14.79,12.86-33.19,28.86-66.71,28.86h-20.01c-24.22,0-46.25-8.62-62.01-24.28
	c-15.39-15.3-23.89-36.22-23.89-58.94v-26.87c0-22.72,8.48-43.66,23.89-58.94c15.77-15.66,37.79-24.28,62.01-24.28h20.01
	c33.51,0,51.92,16,66.71,28.86c15.34,13.34,28.59,24.86,63.89,24.86c5.48,0,10.86-0.43,16.09-1.26c-0.04-0.11-0.08-0.2-0.12-0.3
	c-2.1-5.1-4.57-10.12-7.42-14.96l-23.6-40.1c-21.65-36.8-61.68-59.46-104.98-59.46h-47.21c-43.3,0-83.33,22.67-104.98,59.46
	l-23.6,40.1c-21.65,36.8-21.65,82.12,0,118.91l23.6,40.1c21.65,36.8,61.68,59.45,104.98,59.45h47.21
	c43.3,0,83.33-22.67,104.98-59.45l23.6-40.1c2.85-4.85,5.32-9.85,7.42-14.95c0.04-0.11,0.08-0.2,0.12-0.3
	c-5.23-0.83-10.59-1.26-16.09-1.26C533.87,340.42,520.61,351.94,505.27,365.28z"
    />
    <path
      class="st0"
      fill={fill1 || '#3664AE'}
      d="M438.57,225.16h-20.01c-36.86,0-61.09,25.83-61.09,58.89v26.87c0,33.06,24.22,58.89,61.09,58.89h20.01
	c53.71,0,49.49-53.72,130.59-53.72c7.77,0,15.45,0.7,22.92,2.06c2.46-13.66,2.46-27.64,0-41.31c-7.48,1.36-15.15,2.06-22.92,2.06
	C488.06,278.89,492.28,225.16,438.57,225.16z"
    />
    <path
      class="st0"
      fill={fill1 || '#3664AE'}
      d="M638.66,337.76c-13.85-10.02-29.74-16.56-46.59-19.64c-0.03,0.13-0.04,0.26-0.07,0.39
	c-1.44,7.87-3.69,15.62-6.77,23.14c14.22,2.26,27.32,7.5,38.52,15.55c-0.04,0.12-0.07,0.24-0.11,0.37
	c-6.46,20.57-16.2,39.96-28.93,57.6c-12.58,17.42-27.79,32.76-45.22,45.57c-36.18,26.62-79.27,40.68-124.63,40.68
	c-28.08,0-55.31-5.39-80.94-16.02c-24.75-10.27-46.99-24.98-66.11-43.73c-19.11-18.75-34.1-40.56-44.57-64.85
	c-10.83-25.14-16.33-51.85-16.33-79.4c0-27.55,5.5-54.26,16.33-79.4c10.47-24.28,25.46-46.1,44.57-64.85
	c19.11-18.75,41.35-33.45,66.11-43.73c25.62-10.63,52.85-16.02,80.94-16.02c45.36,0,88.45,14.06,124.63,40.68
	c17.43,12.82,32.63,28.15,45.22,45.57c12.73,17.65,22.47,37.04,28.93,57.6c0.04,0.13,0.08,0.25,0.11,0.37
	c-11.19,8.04-24.3,13.3-38.52,15.55c3.08,7.53,5.34,15.3,6.77,23.17c0.03,0.13,0.04,0.25,0.07,0.38
	c16.85-3.08,32.73-9.62,46.59-19.64c13.28-9.64,10.71-20.53,8.69-26.99C618.08,136.9,529.55,69.12,424.87,69.12
	c-128.55,0-232.75,102.22-232.75,228.32c0,126.1,104.21,228.32,232.75,228.32c104.68,0,193.21-67.79,222.48-161.05
	C649.38,358.29,651.96,347.41,638.66,337.76z"
    />
    <path
      class="st1"
      fill={fill2 || '#5FC2D6'}
      d="M585.25,253.26c-5.23,0.83-10.59,1.26-16.09,1.26c-35.29,0-48.55-11.52-63.89-24.86
	c-14.79-12.86-33.19-28.86-66.71-28.86h-20.01c-24.22,0-46.25,8.62-62.01,24.28c-15.39,15.3-23.89,36.22-23.89,58.94v26.87
	c0,22.72,8.48,43.66,23.89,58.94c15.77,15.66,37.79,24.28,62.01,24.28h20.01c33.51,0,51.92-16.01,66.71-28.86
	c15.34-13.34,28.59-24.86,63.89-24.86c5.48,0,10.86,0.43,16.09,1.26c3.08-7.52,5.32-15.28,6.77-23.14c0.03-0.13,0.04-0.26,0.07-0.39
	c-7.48-1.36-15.15-2.06-22.92-2.06c-81.1,0-76.88,53.72-130.59,53.72h-20.01c-36.86,0-61.09-25.83-61.09-58.89v-26.87
	c0-33.06,24.22-58.89,61.09-58.89h20.01c53.71,0,49.5,53.72,130.59,53.72c7.77,0,15.45-0.7,22.92-2.06
	c-0.03-0.13-0.04-0.25-0.07-0.38C590.59,268.56,588.33,260.8,585.25,253.26z"
    />
    <path
      class="st1"
      fill={fill2 || '#5FC2D6'}
      d="M585.25,253.26c-5.23,0.83-10.59,1.26-16.09,1.26c-35.29,0-48.55-11.52-63.89-24.86
	c-14.79-12.86-33.19-28.86-66.71-28.86h-20.01c-24.22,0-46.25,8.62-62.01,24.28c-15.39,15.3-23.89,36.22-23.89,58.94v26.87
	c0,22.72,8.48,43.66,23.89,58.94c15.77,15.66,37.79,24.28,62.01,24.28h20.01c33.51,0,51.92-16.01,66.71-28.86
	c15.34-13.34,28.59-24.86,63.89-24.86c5.48,0,10.86,0.43,16.09,1.26c3.08-7.52,5.32-15.28,6.77-23.14c0.03-0.13,0.04-0.26,0.07-0.39
	c-7.48-1.36-15.15-2.06-22.92-2.06c-81.1,0-76.88,53.72-130.59,53.72h-20.01c-36.86,0-61.09-25.83-61.09-58.89v-26.87
	c0-33.06,24.22-58.89,61.09-58.89h20.01c53.71,0,49.5,53.72,130.59,53.72c7.77,0,15.45-0.7,22.92-2.06
	c-0.03-0.13-0.04-0.25-0.07-0.38C590.59,268.56,588.33,260.8,585.25,253.26z"
    />
  </svg>
);

export const SelfIconSmall = ({ width, height }) => (
  <svg
    id="eouaMDRZGTz1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 340 340"
    width={width || '48px'}
    height={height || '48px'}
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
  >
    <a href="https://www.linkedin.com/in/lanny-macmillan/" target="_parent">
      <g transform="translate(-30.851303-26.043648)">
        <ellipse
          rx="141.750934"
          ry="141.750934"
          transform="matrix(1.1 0 0 1.1 200.851307 194.244745)"
          fill="#141c3a"
          strokeWidth="15"
        />
        <g>
          <g>
            <path
              d="M219.37,286.8v-32.8h37.57c9.388841,0,17,7.611159,17,17s-7.611159,17-17,17h-37.57v-1.2"
              fill="#202c33"
            />
            <path
              d="M181.09,286.8v-32.8h-37.58c-9.388841,0-17,7.611159-17,17s7.611159,17,17,17h37.57v-1.2"
              fill="#202c33"
            />
          </g>
          <path
            d="M287.518756,325.62h7.481244c-.087874-30.201116-16.338884-42.482126-46.54-42.57h-3.46c-10.816629-.032944-19.577056-8.793371-19.61-19.61v-19.71h-50.33v19.74c-.032944,10.816629-8.793371,19.577056-19.61,19.61h-3.45c-30.201116.087874-40.125179,7.188884-40.213053,37.39L118.15,325.62c0,2.185384,3.9247,4.8947,5.47,6.44s42.694616,15.38,44.88,15.38l67.22,2.730772c4.539106-.016526,51.798786-20.011636,51.798756-24.550772Z"
            fill="#f7c299"
          />
          <path
            d="M199.85,282.58h.75c10.097136.011202,20.047003-2.421369,29-7.09-2.692579-3.421262-4.160771-7.646274-4.17-12v-19.76h-50.37v19.74c-.009229,4.353726-1.477421,8.578738-4.17,12c8.938971,4.670052,18.874635,7.109367,28.96,7.11Z"
            fill="#cf946d"
          />
          <g>
            <path
              d="M172.57,353.33h57.03l.98-55.42c-19.019364,10.559308-42.140636,10.559308-61.16,0Z"
              fill="#109494"
            />
            <path
              d="M169.42,310.87c19.019364,10.559308,42.140636,10.559308,61.16,0"
              fill="none"
              stroke="#4fecec"
              strokeWidth="8.24112"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <path
              d="M153.8,343.8c-3.250637-.002649-22.614267-3.67864-24.91-5.98s-5.275308-2.019366-5.27-5.27l-22.34-12.08c.090639-26.44996,9.76624-32.268091,35.27-39.28.345476-.093892.701994-.14098,1.06-.14h26c10.267927.011023,18.588977,8.332073,18.6,18.6l.01168,50.520772c.015577.229736.003897-.229736-.01168,0-.177034,2.075374.952897.007537-1.13,0Z"
              fill="#35444d"
            />
            <path
              d="M224.62,350.170772c-2.082897.007537-4.602966,2.987671-4.78.912297-.015607-.229735-2.715607-.682562-2.7-.912297L218.33,299.67c.011023-10.267927,8.332073-18.588977,18.6-18.6h26c.358006-.00098.714524.046108,1.06.14c25.50376,7.011909,34.639361,12.81004,34.73,39.26l-11.201244,5.15c.005339,3.259309-8.832198,4.627195-11.138756,6.93s-5.151727,5.280647-8.411023,5.27Z"
              fill="#35444d"
            />
            <line
              x1="142.39"
              y1="343.8"
              x2="142.180214"
              y2="340.374903"
              transform="translate(.394903-.394903)"
              fill="none"
              stroke="#202c33"
              strokeWidth="8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <path
              d="M254.17,266.24c-.743634,4.862876-4.961114,8.431513-9.88,8.36h-4.37c-12.532075.005295-22.708515,10.128128-22.78,22.66l-.574884,50.41c0,2.761424.04346,4.066603,2.804884,4.066603h2.77c2.761424,0,5.394998-1.305179,5.394998-4.066603L227.66,298.59c.033005-5.819728,4.760179-10.520094,10.58-10.52h18.71c9.361572.000079,16.961452-7.568508,17-16.93l-20.47-9.9c.675201,1.574361.913561,3.30161.69,5Z"
              fill="#202c33"
            />
            <path
              d="M174,279c-3.903001-2.873557-8.623275-4.422452-13.47-4.42h-4.37c-4.918886.071513-9.136366-3.497124-9.88-8.36-.226706-1.697491.008195-3.424707.68-5l-20.47,9.9c.038548,9.361492,7.638428,16.930079,17,16.93h18.71c5.819821-.000094,10.546995,4.700272,10.58,10.52l.125116,54.76c0,0-.335116-5.66,2.474884,0h2.4c2.761424,0,4.44168,2.761424,4.44168,0L183.3,297.26c-.008739-7.221936-3.463923-14.005985-9.3-18.26Z"
              fill="#202c33"
            />
            <path
              d="M160.54,274.66h-4.67c-5.328233-.016471-9.643529-4.331767-9.66-9.66v0c-.001408-1.288388.25708-2.563822.76-3.75"
              fill="none"
              stroke="#68717d"
              strokeWidth="4"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <line
              x1="157.05"
              y1="285.85"
              x2="157.05"
              y2="332.55"
              fill="none"
              stroke="#fff"
              strokeWidth="8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <circle r="7.69" transform="translate(156.82 339.75)" fill="#109494" />
            <line
              x1="243.41"
              y1="285.85"
              x2="243.41"
              y2="332.55"
              fill="none"
              stroke="#fff"
              strokeWidth="8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <circle r="7.69" transform="translate(243.41 339.98)" fill="#109494" />
            <path
              d="M239.92,274.66h4.67c5.328233-.016471,9.643529-4.331767,9.66-9.66v0c.001408-1.288388-.25708-2.563822-.76-3.75"
              fill="none"
              stroke="#68717d"
              strokeWidth="4"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </g>
        </g>
        <ellipse
          rx="141.750934"
          ry="141.750934"
          transform="matrix(1.1 0 0 1.1 200.851307 194.244745)"
          fill="none"
          stroke="#4fecec"
          strokeWidth="15"
        />
        <g>
          <g>
            <path
              d="M276.38,178v-43.23c-.071297-30.467898-24.732217-55.160091-55.2-55.27h-42.36c-30.467783.109909-55.128703,24.802102-55.2,55.27v43.23"
              fill="none"
              stroke="#109494"
              strokeWidth="14"
              strokeMiterlimit="10"
            />
            <rect
              width="55.22"
              height="61.05"
              rx="16.38"
              ry="16.38"
              transform="translate(101.28 154.48)"
              fill="#109494"
            />
            <line
              x1="118.15"
              y1="173.26"
              x2="118.15"
              y2="196.81"
              fill="none"
              stroke="#4fecec"
              strokeWidth="16"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <rect
              width="55.22"
              height="61.05"
              rx="16.38"
              ry="16.38"
              transform="matrix(-1 0 0-1 298.72 215.53)"
              fill="#109494"
            />
            <line
              x1="281.85"
              y1="173.26"
              x2="281.85"
              y2="196.81"
              fill="none"
              stroke="#4fecec"
              strokeWidth="16"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </g>
          <path
            d="M189,82.68h22c29.005995,0,52.52,23.514005,52.52,52.52v56.07c.002654,14.783061-5.869403,28.961263-16.323544,39.413528s-24.633395,16.321778-39.416456,16.316472h-15.56c-30.773306,0-55.72-24.946694-55.72-55.72v-56.08c-.000002-28.998186,23.501816-52.508957,52.5-52.52Z"
            transform="translate(-.107127 0)"
            fill="#f7c299"
          />
          <path
            d="M206.78,184.3c-1.419143-2.363024-3.954822-3.829029-6.710774-3.879839s-5.343945,1.320732-6.849226,3.629839"
            transform="translate(0-.469462)"
            fill="none"
            stroke="#cf946d"
            strokeWidth="4"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <path
            d="M184,205.46v.29c0,7.29,5.79,13.82,13.84,14.78c9.74,1.16,18.14-5.7,18.14-14.24v-.83c-.129057-2.260745-2.058426-3.993604-4.32-3.88h-23.33c-2.265381-.1193-4.200992,1.615151-4.33,3.88Z"
            fill="#fff"
          />
          <g>
            <ellipse
              rx="6.88"
              ry="7.43"
              transform="translate(168.5 165.61)"
              fill="#02468e"
            />
            <ellipse
              rx="6.88"
              ry="7.43"
              transform="translate(231.5 165.61)"
              fill="#02468e"
            />
          </g>
          <g>
            <line
              x1="219.84"
              y1="140.85"
              x2="243.17"
              y2="140.85"
              fill="none"
              stroke="#77655a"
              strokeWidth="12"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <line
              x1="157.83"
              y1="140.85"
              x2="181.16"
              y2="140.85"
              fill="none"
              stroke="#77655a"
              strokeWidth="12"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </g>
          <g>
            <path
              d="M203.84,73.93h-7.68c-35.45,0-63.52,30.67-63.52,68.15v40.57h9.47v-51.4c.140959-5.143259,4.354815-9.237353,9.5-9.23l3.7.06c.68-10.11,8.92-24.68,18.93-24.68h51.51c10,0,18.24,14.55,18.93,24.66h3.71c5.08,0,9.6,4.15,9.6,9.23v51.4h9.37v-40.61c0-37.48-28.07-68.15-63.52-68.15Z"
              transform="translate(.608977 0)"
              fill="#9f8b7f"
            />
            <path
              d="M249.83,53c-.039193-10.58628-8.477664-19.228408-19.06-19.52-2.531847,7.573103-9.400783,12.856292-17.37,13.36h-36.74c-14.617311.043929-26.456071,11.882689-26.5,26.5v4.56c.032944,10.783492,8.766508,19.517056,19.55,19.55h60.57c10.783492-.032944,19.517056-8.766508,19.55-19.55v-11.54c0-.31,0-.61,0-.92s0-.61,0-.92Z"
              transform="translate(-2.745002 4.050005)"
              fill="#77655a"
            />
          </g>
          <path
            d="M262.63,152.79v32.85c-.058472,17.102082-13.273851,31.276044-30.33,32.53v-7.44c.083519-10.634988-8.435716-19.341851-19.07-19.49h-17.09c-10.634284.148149-19.153519,8.855012-19.07,19.49v7.44c-17.059971-1.254254-30.276743-15.434068-30.33-32.54v-32.84c-6.076347,7.169127-9.410951,16.262214-9.41,25.66v18.18c.098836,32.61557,26.51443,59.031164,59.13,59.13h16.46c32.596043-.126257,58.981318-26.533862,59.08-59.13v-18.18c.01213-9.392744-3.308088-18.485252-9.37-25.66Zm-65.75,50.3h15.6c4.603825.054925,8.294439,3.826062,8.25,8.43v6.75v0v5.73c-.00037,1.492172-.393544,2.957954-1.14,4.25v0c-.995899,1.456297-2.64574,2.327982-4.41,2.33h-1.43c-2.952441-.005503-5.344497-2.397559-5.35-5.35v-1.44c.016952-1.542874.702922-3.002385,1.88-4h-11.2c1.177078.997615,1.863048,2.457126,1.88,4v1.44c-.005503,2.952441-2.397559,5.344497-5.35,5.35h-1.43c-1.899012-.008751-3.650504-1.025378-4.6-2.67-.643589-1.207287-.986614-2.551947-1-3.92v-12.47c-.021307-2.219746.842148-4.356614,2.399574-5.938433s3.680617-2.478377,5.900426-2.491567Z"
            transform="translate(-4.164884 0.378625)"
            fill="#77655a"
          />
          <g>
            <path
              d="M186.24,237.64h-45.24c-8.836556,0-16-7.163444-16-16v-6.14"
              fill="none"
              stroke="#4fecec"
              strokeWidth="12"
              strokeMiterlimit="10"
            />
            <rect
              width="21.73"
              height="29.46"
              rx="7.14"
              ry="7.14"
              transform="matrix(0 1-1 0 202.03 226.78)"
              fill="#109494"
            />
          </g>
        </g>
      </g>
    </a>
  </svg>
);

export const SelfIconLarge = ({ width, height }) => (
  <svg
    cache-id="4c9ed7f35cff4cc39b2da1b4f508f440"
    id="eJkwr3sNFQm1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    width={width || '48px'}
    height={height || '48px'}
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
  >
    <g transform="translate(52.685838 32.03409)">
      <ellipse
        rx="141.750934"
        ry="141.750934"
        transform="matrix(1.1 0 0 1.1 200.851307 194.244745)"
        fill="#141c3a"
        stroke="#4fecec"
        strokeWidth="15"
      />
      <g>
        <g>
          <path
            d="M219.37,286.8v-32.8h37.57c9.388841,0,17,7.611159,17,17s-7.611159,17-17,17h-37.57v-1.2"
            fill="#202c33"
          />
          <path
            d="M181.09,286.8v-32.8h-37.58c-9.388841,0-17,7.611159-17,17s7.611159,17,17,17h37.57v-1.2"
            fill="#202c33"
          />
        </g>
        <path
          d="M303.21,363v-25.2c-.087874-30.201116-24.548884-54.662126-54.75-54.75h-3.46c-10.816629-.032944-19.577056-8.793371-19.61-19.61v-19.71h-50.33v19.74c-.032944,10.816629-8.793371,19.577056-19.61,19.61h-3.45c-30.201116.087874-54.662126,24.548884-54.75,54.75v25.17c0,2.185384.86814,4.28126,2.41344,5.82656s3.641176,2.41344,5.82656,2.41344h189.51c4.539106-.016526,8.21003-3.700864,8.21-8.24Z"
          fill="#f7c299"
        />
        <path
          d="M199.85,282.58h.75c10.097136.011202,20.047003-2.421369,29-7.09-2.692579-3.421262-4.160771-7.646274-4.17-12v-19.76h-50.37v19.74c-.009229,4.353726-1.477421,8.578738-4.17,12c8.938971,4.670052,18.874635,7.109367,28.96,7.11Z"
          fill="#cf946d"
        />
        <g>
          <path
            d="M169.42,375h61.16v-77.09c-19.019364,10.559308-42.140636,10.559308-61.16,0Z"
            fill="#109494"
          />
          <path
            d="M169.42,310.87c19.019364,10.559308,42.140636,10.559308,61.16,0"
            fill="none"
            stroke="#4fecec"
            strokeWidth="8.24112"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <path
            d="M105.49,375.27c-3.250637-.002649-6.366937-1.297187-8.66267-3.598547s-3.582638-5.420819-3.57733-8.671453v-25.2c.090639-26.44996,17.79624-49.598091,43.3-56.61.345476-.093892.701994-.14098,1.06-.14h26c10.267927.011023,18.588977,8.332073,18.6,18.6v71.25c.015577.229736.015577.460264,0,.69-.177034,2.075374-1.917103,3.667537-4,3.66Z"
            fill="#35444d"
          />
          <path
            d="M222.33,375.27c-2.082897.007537-3.822966-1.584626-4-3.66-.015607-.229735-.015607-.460265,0-.69v-71.25c.011023-10.267927,8.332073-18.588977,18.6-18.6h26c.358006-.00098.714524.046108,1.06.14c25.50376,7.011909,43.209361,30.16004,43.3,56.61v25.18c.005339,3.259309-1.288424,6.386369-3.594982,8.689174s-5.435722,3.591473-8.695018,3.580826Z"
            fill="#35444d"
          />
          <line
            x1="142.39"
            y1="343.8"
            x2="142.39"
            y2="362.86"
            fill="none"
            stroke="#202c33"
            strokeWidth="8"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <line
            x1="258.07"
            y1="343.8"
            x2="258.07"
            y2="362.86"
            fill="none"
            stroke="#202c33"
            strokeWidth="8"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <path
            d="M254.17,266.24c-.743634,4.862876-4.961114,8.431513-9.88,8.36h-4.37c-12.532075.005295-22.708515,10.128128-22.78,22.66v77.44c0,2.761424,2.238576,5,5,5h.52c2.761424,0,5-2.238576,5-5v-76.11c.033005-5.819728,4.760179-10.520094,10.58-10.52h18.71c9.361572.000079,16.961452-7.568508,17-16.93l-20.47-9.9c.675201,1.574361.913561,3.30161.69,5Z"
            fill="#202c33"
          />
          <path
            d="M174,279c-3.903001-2.873557-8.623275-4.422452-13.47-4.42h-4.37c-4.918886.071513-9.136366-3.497124-9.88-8.36-.226706-1.697491.008195-3.424707.68-5l-20.47,9.9c.038548,9.361492,7.638428,16.930079,17,16.93h18.71c5.819821-.000094,10.546995,4.700272,10.58,10.52v76.13c0,2.761424,2.238576,5,5,5h.52c2.761424,0,5-2.238576,5-5v-77.44c-.008739-7.221936-3.463923-14.005985-9.3-18.26Z"
            fill="#202c33"
          />
          <path
            d="M160.54,274.66h-4.67c-5.328233-.016471-9.643529-4.331767-9.66-9.66v0c-.001408-1.288388.25708-2.563822.76-3.75"
            fill="none"
            stroke="#68717d"
            strokeWidth="4"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <line
            x1="157.05"
            y1="285.85"
            x2="157.05"
            y2="332.55"
            fill="none"
            stroke="#fff"
            strokeWidth="8"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <circle r="7.69" transform="translate(156.82 339.75)" fill="#109494" />
          <line
            x1="243.41"
            y1="285.85"
            x2="243.41"
            y2="332.55"
            fill="none"
            stroke="#fff"
            strokeWidth="8"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <circle r="7.69" transform="translate(243.41 339.98)" fill="#109494" />
          <path
            d="M239.92,274.66h4.67c5.328233-.016471,9.643529-4.331767,9.66-9.66v0c.001408-1.288388-.25708-2.563822-.76-3.75"
            fill="none"
            stroke="#68717d"
            strokeWidth="4"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M276.38,178v-43.23c-.071297-30.467898-24.732217-55.160091-55.2-55.27h-42.36c-30.467783.109909-55.128703,24.802102-55.2,55.27v43.23"
            fill="none"
            stroke="#109494"
            strokeWidth="14"
            strokeMiterlimit="10"
          />
          <rect
            width="55.22"
            height="61.05"
            rx="16.38"
            ry="16.38"
            transform="translate(101.28 154.48)"
            fill="#109494"
          />
          <line
            x1="118.15"
            y1="173.26"
            x2="118.15"
            y2="196.81"
            fill="none"
            stroke="#4fecec"
            strokeWidth="16"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <rect
            width="55.22"
            height="61.05"
            rx="16.38"
            ry="16.38"
            transform="matrix(-1 0 0-1 298.72 215.53)"
            fill="#109494"
          />
          <line
            x1="281.85"
            y1="173.26"
            x2="281.85"
            y2="196.81"
            fill="none"
            stroke="#4fecec"
            strokeWidth="16"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M189,82.68h22c29.005995,0,52.52,23.514005,52.52,52.52v56.07c.002654,14.783061-5.869403,28.961263-16.323544,39.413528s-24.633395,16.321778-39.416456,16.316472h-15.56c-30.773306,0-55.72-24.946694-55.72-55.72v-56.08c-.000002-28.998186,23.501816-52.508957,52.5-52.52Z"
          transform="translate(-.107127 0)"
          fill="#f7c299"
        />
        <path
          d="M206.78,184.3c-1.419143-2.363024-3.954822-3.829029-6.710774-3.879839s-5.343945,1.320732-6.849226,3.629839"
          transform="translate(0-.469462)"
          fill="none"
          stroke="#cf946d"
          strokeWidth="4"
          strokeLinecap="round"
          strokeMiterlimit="10"
        />
        <path
          d="M184,205.46v.29c0,7.29,5.79,13.82,13.84,14.78c9.74,1.16,18.14-5.7,18.14-14.24v-.83c-.129057-2.260745-2.058426-3.993604-4.32-3.88h-23.33c-2.265381-.1193-4.200992,1.615151-4.33,3.88Z"
          fill="#fff"
        />
        <g>
          <ellipse
            rx="6.88"
            ry="7.43"
            transform="translate(168.5 165.61)"
            fill="#02468e"
          />
          <ellipse
            rx="6.88"
            ry="7.43"
            transform="translate(231.5 165.61)"
            fill="#02468e"
          />
        </g>
        <g>
          <line
            x1="219.84"
            y1="140.85"
            x2="243.17"
            y2="140.85"
            fill="none"
            stroke="#77655a"
            strokeWidth="12"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <line
            x1="157.83"
            y1="140.85"
            x2="181.16"
            y2="140.85"
            fill="none"
            stroke="#77655a"
            strokeWidth="12"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <path
            d="M203.84,73.93h-7.68c-35.45,0-63.52,30.67-63.52,68.15v40.57h9.47v-51.4c.140959-5.143259,4.354815-9.237353,9.5-9.23l3.7.06c.68-10.11,8.92-24.68,18.93-24.68h51.51c10,0,18.24,14.55,18.93,24.66h3.71c5.08,0,9.6,4.15,9.6,9.23v51.4h9.37v-40.61c0-37.48-28.07-68.15-63.52-68.15Z"
            transform="translate(.608977 0)"
            fill="#9f8b7f"
          />
          <path
            d="M249.83,53c-.039193-10.58628-8.477664-19.228408-19.06-19.52-2.531847,7.573103-9.400783,12.856292-17.37,13.36h-36.74c-14.617311.043929-26.456071,11.882689-26.5,26.5v4.56c.032944,10.783492,8.766508,19.517056,19.55,19.55h60.57c10.783492-.032944,19.517056-8.766508,19.55-19.55v-11.54c0-.31,0-.61,0-.92s0-.61,0-.92Z"
            transform="translate(-2.745002 4.050005)"
            fill="#77655a"
          />
        </g>
        <path
          d="M262.63,152.79v32.85c-.058472,17.102082-13.273851,31.276044-30.33,32.53v-7.44c.083519-10.634988-8.435716-19.341851-19.07-19.49h-17.09c-10.634284.148149-19.153519,8.855012-19.07,19.49v7.44c-17.059971-1.254254-30.276743-15.434068-30.33-32.54v-32.84c-6.076347,7.169127-9.410951,16.262214-9.41,25.66v18.18c.098836,32.61557,26.51443,59.031164,59.13,59.13h16.46c32.596043-.126257,58.981318-26.533862,59.08-59.13v-18.18c.01213-9.392744-3.308088-18.485252-9.37-25.66Zm-65.75,50.3h15.6c4.603825.054925,8.294439,3.826062,8.25,8.43v6.75v0v5.73c-.00037,1.492172-.393544,2.957954-1.14,4.25v0c-.995899,1.456297-2.64574,2.327982-4.41,2.33h-1.43c-2.952441-.005503-5.344497-2.397559-5.35-5.35v-1.44c.016952-1.542874.702922-3.002385,1.88-4h-11.2c1.177078.997615,1.863048,2.457126,1.88,4v1.44c-.005503,2.952441-2.397559,5.344497-5.35,5.35h-1.43c-1.899012-.008751-3.650504-1.025378-4.6-2.67-.643589-1.207287-.986614-2.551947-1-3.92v-12.47c-.021307-2.219746.842148-4.356614,2.399574-5.938433s3.680617-2.478377,5.900426-2.491567Z"
          transform="translate(-4.164884 0.378625)"
          fill="#77655a"
        />
        <g>
          <path
            d="M186.24,237.64h-45.24c-8.836556,0-16-7.163444-16-16v-6.14"
            fill="none"
            stroke="#4fecec"
            strokeWidth="12"
            strokeMiterlimit="10"
          />
          <rect
            width="21.73"
            height="29.46"
            rx="7.14"
            ry="7.14"
            transform="matrix(0 1-1 0 202.03 226.78)"
            fill="#109494"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const NextJSIcon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={width || '48px'}
    height={height || '48px'}
    baseProfile="basic"
  >
    <linearGradient
      id="NRNx2IPDe7PJlJvrxOKgWa"
      x1="24"
      x2="24"
      y1="43.734"
      y2="4.266"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#0a070a" />
      <stop offset=".465" stopColor="#2b2b2b" />
      <stop offset="1" stopColor="#4b4b4b" />
    </linearGradient>
    <circle cx="24" cy="24" r="19.734" fill="url(#NRNx2IPDe7PJlJvrxOKgWa)" />
    <rect width="3.023" height="15.996" x="15.992" y="16.027" fill="#fff" />
    <linearGradient
      id="NRNx2IPDe7PJlJvrxOKgWb"
      x1="30.512"
      x2="30.512"
      y1="33.021"
      y2="18.431"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".377" stopColor="#fff" stopOpacity="0" />
      <stop offset=".666" stopColor="#fff" stopOpacity=".3" />
      <stop offset=".988" stopColor="#fff" />
    </linearGradient>
    <rect
      width="2.953"
      height="14.59"
      x="29.035"
      y="15.957"
      fill="url(#NRNx2IPDe7PJlJvrxOKgWb)"
    />
    <linearGradient
      id="NRNx2IPDe7PJlJvrxOKgWc"
      x1="22.102"
      x2="36.661"
      y1="21.443"
      y2="40.529"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".296" stopColor="#fff" />
      <stop offset=".521" stopColor="#fff" stopOpacity=".5" />
      <stop offset=".838" stopColor="#fff" stopOpacity="0" />
    </linearGradient>
    <polygon
      fill="url(#NRNx2IPDe7PJlJvrxOKgWc)"
      points="36.781,38.094 34.168,39.09 15.992,16.027 19.508,16.027"
    />
  </svg>
);
export const NextJSColorIcon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width={width || '48px'}
    height={height || '48px'}
    baseProfile="basic"
  >
    <linearGradient
      id="wNc8qMg_PMLZF-NebSkXWa"
      x1="32"
      x2="32"
      y1="54"
      y2="10"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#e6abff" />
      <stop offset="1" stopColor="#6dc7ff" />
    </linearGradient>
    <path
      fill="url(#wNc8qMg_PMLZF-NebSkXWa)"
      d="M54,32c0,5.75-2.2,10.98-5.8,14.9l-0.171,0.187L43,40.646V21h-7v10.686L27.663,21H21v22h7	V32.59l14.66,18.66C39.51,53,35.87,54,32,54c-12.15,0-22-9.85-22-22s9.85-22,22-22S54,19.85,54,32z"
    />
    <linearGradient
      id="wNc8qMg_PMLZF-NebSkXWb"
      x1="32"
      x2="32"
      y1="58"
      y2="6"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#c822ff" />
      <stop offset="1" stopColor="#1a6dff" />
    </linearGradient>
    <path
      fill="url(#wNc8qMg_PMLZF-NebSkXWb)"
      d="M32,58C17.663,58,6,46.336,6,32S17.663,6,32,6s26,11.664,26,26S46.337,58,32,58z M32,8	C18.767,8,8,18.767,8,32s10.767,24,24,24s24-10.767,24-24S45.233,8,32,8z M41,41.336V23h-3v14.496L26.683,23H23v18h3V26.81	L44.37,50.2c0.771-0.523,1.509-1.097,2.212-1.714L41,41.336z"
    />
  </svg>
);
